(function(){"use strict";try{if(typeof document!="undefined"){var a=document.createElement("style");a.appendChild(document.createTextNode('.stream-provider[data-v-82e0d6e5]{width:100%;height:100%;position:relative}.draggable-layout[data-v-065f0480]{user-select:none;touch-action:none;cursor:grab}.draggable-layout.dragging[data-v-065f0480]{cursor:grabbing;opacity:.9;z-index:1000}.drag-handle[data-v-065f0480]{position:absolute;z-index:1}.drag-handle.top[data-v-065f0480]{top:0;left:0;right:0;height:20px}.drag-handle.bottom[data-v-065f0480]{bottom:0;left:0;right:0;height:20px}.drag-handle.top-left[data-v-065f0480]{top:0;left:0;width:20px;height:20px}.drag-handle.top-right[data-v-065f0480]{top:0;right:0;width:20px;height:20px}.drag-handle.bottom-left[data-v-065f0480]{bottom:0;left:0;width:20px;height:20px}.drag-handle.bottom-right[data-v-065f0480]{bottom:0;right:0;width:20px;height:20px}.default-handle[data-v-065f0480]{width:100%;height:100%;background:#0000001a;transition:background-color .2s;display:flex;align-items:center;justify-content:center}.default-handle[data-v-065f0480]:hover{background:#0003}.default-handle[data-v-065f0480]:before{content:"⋮⋮";color:#ffffffb3;font-size:12px;letter-spacing:2px}.viewer-count[data-v-66d9289a]{display:flex;align-items:center;gap:6px;font-size:14px;padding:6px 10px;border-radius:5px;box-shadow:0 2px 8px #00000026}.viewer-count-text[data-v-66d9289a]{line-height:1;font-weight:500}.live-badge[data-v-9875bbcf]{display:flex;align-items:center;gap:6px;border-radius:5px;box-shadow:0 2px 8px #00000026}.live-dot[data-v-9875bbcf]{border-radius:50%;background-color:red;animation:flicker-9875bbcf 1s infinite}.live-dot.paused[data-v-9875bbcf]{background-color:#666;animation:none}.live-text[data-v-9875bbcf]{line-height:1;font-weight:500}@keyframes flicker-9875bbcf{0%,to{opacity:1}50%{opacity:.4}}.host-view[data-v-9b5f6bbd]{position:relative;width:100%;min-height:400px;background-color:var(--0753c819);color:#fff;border-radius:var(--dca35dcc);overflow:hidden;--badge-font-size: var(--a8b58d16);--badge-dot-size: var(--d87e6076);--countdown-number-size: var(--c1404386);--live-message-size: var(--69873144)}.video-container[data-v-9b5f6bbd]{width:100%;height:100%;border-radius:var(--dca35dcc);overflow:hidden;background-color:var(--0753c819)}.view-video[data-v-9b5f6bbd]{width:100%;height:100%;border-radius:var(--dca35dcc);object-fit:var(--9710865c);background-color:var(--0753c819)}.view-placeholder[data-v-9b5f6bbd]{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background-color:var(--0753c819)}.permission-button-overlay[data-v-9b5f6bbd]{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;z-index:15}.permission-prompt-container[data-v-9b5f6bbd]{display:flex;flex-direction:column;align-items:center;gap:24px;text-align:center;max-width:600px;padding:40px 32px;background:#0000004d;border-radius:16px;backdrop-filter:blur(10px)}.permission-prompt-text[data-v-9b5f6bbd]{color:#fff;font-size:20px;margin:0;line-height:1.4;text-shadow:0 1px 3px rgba(0,0,0,.5)}@media (max-width: 768px){.permission-prompt-container[data-v-9b5f6bbd]{max-width:90%;padding:32px 24px;gap:20px}.permission-prompt-text[data-v-9b5f6bbd]{font-size:18px}}@media (max-width: 480px){.permission-prompt-container[data-v-9b5f6bbd]{max-width:90%;padding:24px 16px;gap:16px}.permission-prompt-text[data-v-9b5f6bbd]{font-size:16px}}.permission-button[data-v-9b5f6bbd]{background:#1976d2;color:#fff;border:none;border-radius:8px;padding:12px 20px;font-size:14px;font-weight:500;cursor:pointer;display:flex;align-items:center;gap:8px;transition:all .2s ease;box-shadow:0 2px 8px #1976d24d}.permission-button[data-v-9b5f6bbd]:hover{background:#1565c0;transform:translateY(-1px);box-shadow:0 4px 12px #1976d266}.permission-button svg[data-v-9b5f6bbd]{color:#ea4335}.live-controls[data-v-9b5f6bbd]{position:absolute;bottom:16px;left:50%;transform:translate(-50%);z-index:20}.status-overlay[data-v-9b5f6bbd]{position:absolute;top:16px;right:16px;padding:4px;z-index:10;display:flex;gap:8px}.loading-overlay[data-v-9b5f6bbd]{position:absolute;inset:0;background:#000000b3;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;z-index:20}.spinner[data-v-9b5f6bbd]{width:20px;height:20px;border:2px solid rgba(255,255,255,.2);border-radius:50%;border-top-color:#fff;animation:spin-9b5f6bbd 1s cubic-bezier(.5,0,.5,1) infinite;margin-bottom:10px}@keyframes spin-9b5f6bbd{to{transform:rotate(360deg)}}.loading-overlay p[data-v-9b5f6bbd]{font-size:14px;color:#fff}.screen-share-view[data-v-9b5f6bbd]{width:100%;height:100%;object-fit:contain;background-color:var(--0753c819);position:absolute;top:0;left:0;z-index:10;border-radius:var(--dca35dcc);object-fit:var(--9710865c)}.view-video.hidden[data-v-9b5f6bbd]{display:none}.floating-video-container[data-v-9b5f6bbd]{width:180px;height:120px;background-color:var(--0753c819);border-radius:var(--dca35dcc);overflow:hidden;box-shadow:0 4px 8px #000c;border:2px solid rgba(255,255,255,.7);z-index:60}.floating-video[data-v-9b5f6bbd]{width:100%;height:100%;object-fit:cover;border-radius:var(--dca35dcc)}.countdown-container[data-v-9b5f6bbd],.message-container[data-v-9b5f6bbd]{display:flex;flex-direction:column;align-items:center;justify-content:center}.countdown-number[data-v-9b5f6bbd]{font-size:var(--countdown-number-size);font-weight:700;color:#fff;margin:0;animation:pulse-9b5f6bbd .5s ease-out}.live-message[data-v-9b5f6bbd]{font-size:var(--live-message-size);font-weight:700;color:#ea4335;margin:0;animation:fadeIn-9b5f6bbd .5s ease-out}.connection-message[data-v-9b5f6bbd]{font-size:16px;font-weight:600;color:#fff;margin:0;animation:fadeIn-9b5f6bbd .5s ease-out;text-align:center}@keyframes pulse-9b5f6bbd{0%{transform:scale(.8);opacity:0}50%{transform:scale(1.2);opacity:1}to{transform:scale(1);opacity:1}}@keyframes fadeIn-9b5f6bbd{0%{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}.connection-minutes-banner[data-v-9b5f6bbd]{position:absolute;top:10px;left:10px;right:10px;background:#fffcf5;border:1px solid #b54708;padding:16px 24px;z-index:100;animation:slideDown-88a9dd25 .3s ease-out;box-shadow:0 4px 6px #0000001a;border-radius:12px}@keyframes slideDown-9b5f6bbd{0%{transform:translateY(-100%);opacity:0}to{transform:translateY(0);opacity:1}}.banner-content[data-v-9b5f6bbd]{display:flex;justify-content:space-between;align-items:center;max-width:1200px;margin:0 auto;gap:24px}.banner-text[data-v-9b5f6bbd]{flex:1;color:#b54708}.banner-title[data-v-9b5f6bbd]{font-size:18px;font-weight:600;margin-bottom:4px}.banner-message[data-v-9b5f6bbd]{font-size:14px;line-height:1.4;opacity:.95}.banner-actions[data-v-9b5f6bbd]{display:flex;gap:12px;flex-shrink:0}.banner-button[data-v-9b5f6bbd]{padding:10px 24px;border-radius:8px;font-size:14px;font-weight:500;cursor:pointer;transition:all .2s;border:none;white-space:nowrap}.continue-button[data-v-9b5f6bbd]{background:#b54708;color:#fff;backdrop-filter:blur(8px);border:1px solid rgba(255,255,255,.3)}.continue-button[data-v-9b5f6bbd]:hover{background:#b54708;transform:translateY(-1px);box-shadow:0 4px 8px #0003}.continue-button[data-v-9b5f6bbd]:active{transform:translateY(0)}.end-button[data-v-9b5f6bbd]{background:#fff;color:#000;font-weight:600;border:1px solid #d0d5dd}.end-button[data-v-9b5f6bbd]:hover{background:#f9fafb;transform:translateY(-1px);box-shadow:0 4px 8px #0003}.end-button[data-v-9b5f6bbd]:active{background:#f3f4f6;transform:translateY(0)}@media (max-width: 1024px){.connection-minutes-banner[data-v-9b5f6bbd]{top:8px;left:8px;right:8px;padding:12px 16px}.banner-content[data-v-9b5f6bbd]{flex-direction:column;align-items:stretch;gap:16px}.banner-title[data-v-9b5f6bbd]{font-size:16px;margin-bottom:6px}.banner-message[data-v-9b5f6bbd]{font-size:13px;line-height:1.5}.banner-actions[data-v-9b5f6bbd]{justify-content:stretch;gap:10px}.banner-button[data-v-9b5f6bbd]{flex:1;padding:10px 16px;font-size:13px;min-height:44px}}@media (max-width: 768px){.connection-minutes-banner[data-v-9b5f6bbd]{top:6px;left:6px;right:6px;padding:10px 12px;border-radius:8px}.banner-content[data-v-9b5f6bbd]{gap:12px}.banner-title[data-v-9b5f6bbd]{font-size:15px;margin-bottom:4px}.banner-message[data-v-9b5f6bbd]{font-size:12px;line-height:1.4}.banner-actions[data-v-9b5f6bbd]{flex-direction:column;gap:8px}.banner-button[data-v-9b5f6bbd]{flex:none;width:100%;padding:12px 16px;font-size:14px;min-height:48px}}@media (max-width: 480px){.connection-minutes-banner[data-v-9b5f6bbd]{top:4px;left:4px;right:4px;padding:8px 10px}.banner-title[data-v-9b5f6bbd]{font-size:14px}.banner-message[data-v-9b5f6bbd]{font-size:11px}.banner-button[data-v-9b5f6bbd]{padding:10px 12px;font-size:13px}}.modal-overlay[data-v-9b5f6bbd]{position:fixed;inset:0;background:#0009;display:flex;align-items:center;justify-content:center;z-index:1000;backdrop-filter:blur(4px)}.modal-content[data-v-9b5f6bbd]{background:#fff;border-radius:12px;box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a;max-width:550px;width:90%;max-height:90vh;overflow:hidden;position:relative}.modal-header[data-v-9b5f6bbd]{display:flex;align-items:center;justify-content:space-between;padding:20px 24px 0}.modal-title[data-v-9b5f6bbd]{font-size:18px;font-weight:600;color:#111827;margin:0}.modal-close[data-v-9b5f6bbd]{background:none;border:none;cursor:pointer;padding:4px;color:#6b7280;border-radius:6px;transition:all .2s;display:flex;align-items:center;justify-content:center}.modal-close[data-v-9b5f6bbd]:hover{background:#f3f4f6;color:#374151}.modal-body[data-v-9b5f6bbd]{padding:16px 24px 24px}.modal-message[data-v-9b5f6bbd]{font-size:14px;line-height:1.5;color:#6b7280;margin:0}.modal-actions[data-v-9b5f6bbd]{display:flex;gap:12px;padding:0 24px 24px;justify-content:flex-end}.modal-button[data-v-9b5f6bbd]{padding:10px 16px;border-radius:8px;font-size:14px;font-weight:500;cursor:pointer;transition:all .2s;border:none;min-width:80px}.cancel-button[data-v-9b5f6bbd]{background:#fff;color:#374151;border:1px solid #d1d5db}.cancel-button[data-v-9b5f6bbd]:hover{background:#fff;border-color:#9ca3af;transform:translateY(-1px);box-shadow:0 4px 8px #1d49814d}.confirm-button[data-v-9b5f6bbd]{background:#1d4981;color:#fff}.confirm-button[data-v-9b5f6bbd]:hover{background:#1e3a72;transform:translateY(-1px);box-shadow:0 4px 8px #1d49814d}.confirm-button[data-v-9b5f6bbd]:active{background:#162f5f;transform:translateY(0);box-shadow:0 2px 4px #1d498133}@media (max-width: 480px){.modal-content[data-v-9b5f6bbd]{margin:16px;width:calc(100% - 32px)}.modal-header[data-v-9b5f6bbd]{padding:16px 20px 0}.modal-title[data-v-9b5f6bbd]{font-size:16px}.modal-body[data-v-9b5f6bbd]{padding:12px 20px 20px}.modal-actions[data-v-9b5f6bbd]{padding:0 20px 20px;flex-direction:column-reverse}.modal-button[data-v-9b5f6bbd]{width:100%;padding:12px 16px}}.control-bar[data-v-a8560bb2]{display:flex;justify-content:center;align-items:center;gap:var(--6afd1946);padding:var(--066c35fc);background:var(--2a46e11f);border-radius:var(--3bf89cee);box-sizing:border-box;width:fit-content;z-index:80;--control-size: var(--291af05f);--icon-size: var(--3e7510a3);--icon-color: var(--6da17cdc);--text-color: var(--faac76b0);--active-color: var(--6da17cdc);font-size:var(--22bcfbfc);color:var(--faac76b0)}.control-bar.position-bottom[data-v-a8560bb2]{position:absolute;bottom:var(--54a8a166);left:50%;transform:translate(-50%)}.control-bar.position-top[data-v-a8560bb2]{position:absolute;top:var(--54a8a166);left:50%;transform:translate(-50%)}.control-bar.position-left[data-v-a8560bb2]{position:absolute;left:var(--54a8a166);top:50%;transform:translateY(-50%)}.control-bar.position-right[data-v-a8560bb2]{position:absolute;right:var(--54a8a166);top:50%;transform:translateY(-50%)}.control-bar.vertical[data-v-a8560bb2]{flex-direction:column;width:fit-content}.control-bar.vertical .controls-group[data-v-a8560bb2]{flex-direction:column}.control-bar.vertical .controls-end[data-v-a8560bb2]{flex-direction:column;margin-top:var(--6afd1946)}.controls-group[data-v-a8560bb2],.controls-end[data-v-a8560bb2]{display:flex;align-items:center;gap:var(--6afd1946)}.control-label[data-v-a8560bb2]{font-size:.75em;font-weight:500;text-align:center;white-space:nowrap;margin-top:4px}.flip-icon[data-v-a8560bb2],.end-icon[data-v-a8560bb2]{display:flex;align-items:center;justify-content:center;width:var(--3e72cac3);height:var(--3e72cac3)}.settings-container[data-v-a8560bb2]{position:relative}.settings-dropdown[data-v-a8560bb2]{position:absolute;background:var(--64500d76);border-radius:var(--3611d5a9);box-shadow:0 4px 24px #0000004d;z-index:1000;width:var(--a30f1170);max-width:90vw;overflow:hidden;padding:6px;border:1px solid rgba(255,255,255,.1);color:var(--6da17cdc)}.dropdown-content[data-v-a8560bb2]{display:flex;flex-direction:column;gap:var(--39f80043)}.device-select[data-v-a8560bb2]{display:flex;flex-direction:column}.select-wrapper[data-v-a8560bb2]{position:relative;display:flex;align-items:center;background:var(--21e44974);border-radius:var(--3611d5a9);padding:var(--664f7beb) var(--48065b4b);border:1px solid rgba(255,255,255,.3)}.device-icon[data-v-a8560bb2]{width:var(--02c67c36);height:var(--02c67c36);margin-right:8px;opacity:.7;color:var(--6da17cdc)}.arrow-icon[data-v-a8560bb2]{position:absolute;right:10px;top:50%;transform:translateY(-50%);width:var(--02c67c36);height:var(--02c67c36);color:var(--6da17cdc);opacity:.7;pointer-events:none}.device-select select[data-v-a8560bb2]{background:transparent;border:none;color:var(--faac76b0);font-size:var(--7b1b86ce);appearance:none;width:100%;padding:var(--1e6e4708) var(--3e72cac3) var(--1e6e4708) 0;background-image:none;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;height:100%;flex:1}.device-select select[data-v-a8560bb2]:focus{outline:none}.device-select select option[data-v-a8560bb2]{background:var(--306cc12f);color:var(--faac76b0);padding:var(--1e6e4708);font-size:var(--7b1b86ce)}.control-bar.position-bottom.screen-share-active[data-v-a8560bb2]{z-index:30}.control-bar.position-left .settings-dropdown[data-v-a8560bb2]{bottom:auto;top:50%;left:100%;transform:translateY(-50%);margin-left:12px}.control-bar.position-right .settings-dropdown[data-v-a8560bb2]{bottom:auto;top:50%;right:100%;transform:translateY(-50%);margin-right:12px}.control-bar.position-top .settings-dropdown[data-v-a8560bb2]{bottom:auto;top:100%;left:50%;transform:translate(-50%);margin-top:12px}.control-bar.position-bottom .settings-dropdown[data-v-a8560bb2]{top:auto;bottom:100%;left:50%;transform:translate(-50%);margin-bottom:12px}@media (max-width: 480px){.settings-dropdown[data-v-a8560bb2]{position:absolute;left:50%;right:auto;bottom:auto;transform:translate(-50%,-50%)}.control-bar.position-right .settings-dropdown[data-v-a8560bb2]{transform:translateY(-50%) translate(-110%)}.control-bar .settings-dropdown[data-v-a8560bb2]{position:fixed}.dropdown-content[data-v-a8560bb2]{max-height:80vh;overflow-y:auto}}.control-bar.no-background[data-v-a8560bb2]{padding:0;background:transparent;backdrop-filter:none;border-radius:0;box-shadow:none}.control-bar.no-background .controls-group[data-v-a8560bb2]{gap:var(--6afd1946)}.control-bar.position-right.no-background[data-v-a8560bb2]{right:12px}.control-bar.position-left.no-background[data-v-a8560bb2]{left:12px}.control-bar.position-bottom.no-background[data-v-a8560bb2]{bottom:12px}.control-bar.position-top.no-background[data-v-a8560bb2]{top:12px}.control-bar.no-background .settings-dropdown[data-v-a8560bb2]{background:var(--7a4a6546);border-radius:12px;box-shadow:0 4px 24px #00000080;padding:6px}.controls-group[data-v-a8560bb2]{display:flex;align-items:center;gap:var(--6afd1946);transition:all .2s ease-out}.controls-group[data-v-a8560bb2]{display:flex;align-items:center;gap:var(--6afd1946);transition:all .3s ease-in-out}.control-item[data-v-a8560bb2]{flex:0 0 auto;width:var(--control-size);height:var(--control-size);display:flex;align-items:center;justify-content:center;box-sizing:border-box;position:relative}.permission-indicator[data-v-a8560bb2]{position:absolute;top:-5px;right:-5px;background:#fa7b16;color:#fff;border-radius:50%;width:16px;height:16px;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;z-index:10}.permission-denied[data-v-a8560bb2]{background-color:#ea4335;border:1px solid rgb(234,67,53);border-radius:10px}.permission-denied[data-v-a8560bb2]:hover{opacity:1;transform:scale(1.05)}.controls-animation-enter-active[data-v-a8560bb2],.controls-animation-leave-active[data-v-a8560bb2]{transition:all .3s ease-in-out}.controls-animation-enter-from[data-v-a8560bb2],.controls-animation-leave-to[data-v-a8560bb2]{opacity:0;transform:scale(.8);width:0;height:0;margin-right:calc(-1 * var(--c3b90532) + "px");margin-left:calc(-1 * var(--c3b90532) + "px")}.controls-animation-move[data-v-a8560bb2]{transition:all .3s ease-in-out}.toggle-button[data-v-a8560bb2]{transition:transform .3s ease-in-out}.toggle-button[data-v-a8560bb2]:hover{transform:scale(1.1)}.mic-meter-wrapper[data-v-a8560bb2]{width:100%;padding:6px 0}.mic-disabled-message[data-v-a8560bb2]{width:100%;text-align:center;padding:4px 0 4px 6px;font-size:12px;opacity:.7;color:var(--faac76b0)}.control-bar.no-background .select-wrapper select[data-v-a8560bb2]{filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}.stream-chat[data-v-fb9e4dc1]{display:flex;flex-direction:column;height:100%;background:#fefeff;color:#333;overflow:hidden;position:relative}.file-size-error-notification[data-v-fb9e4dc1]{padding:16px;animation:slideInFromBottom-fb9e4dc1 .3s ease-out}.error-content[data-v-fb9e4dc1]{background:gold;color:#8b4513;padding:12px 16px;border-radius:8px;display:flex;align-items:center;justify-content:space-between;box-shadow:0 4px 12px #00000026;border:1px solid #e6c200}.error-text[data-v-fb9e4dc1]{font-size:14px;font-weight:500;flex:1;margin-right:12px}.error-dismiss-button[data-v-fb9e4dc1]{background:none;border:none;color:#8b4513;font-size:18px;font-weight:700;cursor:pointer;padding:0;width:24px;height:24px;display:flex;align-items:center;justify-content:center;border-radius:50%;transition:background-color .2s}.error-dismiss-button[data-v-fb9e4dc1]:hover{background-color:#8b45131a}@keyframes slideInFromBottom-fb9e4dc1{0%{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}.stream-chat.inside-player[data-v-fb9e4dc1]{background:transparent;color:#fff}.message-list[data-v-fb9e4dc1]{flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:12px;scrollbar-width:none;-ms-overflow-style:none}.message-list[data-v-fb9e4dc1]::-webkit-scrollbar{display:none}.message-spacer[data-v-fb9e4dc1]{flex:1;min-height:0}.empty-state[data-v-fb9e4dc1]{flex:1;display:flex;align-items:center;justify-content:center;padding:40px 20px;text-align:center}.empty-state-content[data-v-fb9e4dc1]{max-width:300px;animation:fadeIn-fb9e4dc1 .5s ease-out}.empty-state-icon[data-v-fb9e4dc1]{margin-bottom:16px;display:flex;justify-content:center}.icon-circle-outer[data-v-fb9e4dc1]{width:56px;height:56px;border-radius:50%;background-color:#f0f4ff;display:flex;align-items:center;justify-content:center}.icon-circle-inner[data-v-fb9e4dc1]{width:40px;height:40px;border-radius:50%;background-color:#e0e7ff;display:flex;align-items:center;justify-content:center;color:#2563eb}.empty-state-heading[data-v-fb9e4dc1]{font-size:18px;font-weight:600;color:#333;margin:0 0 8px;line-height:1.3}.empty-state-message[data-v-fb9e4dc1]{font-size:14px;color:#666;margin:0;line-height:1.4}.stream-chat.inside-player .empty-state-heading[data-v-fb9e4dc1]{color:#fff;text-shadow:0 1px 2px rgba(0,0,0,.5)}.stream-chat.inside-player .empty-state-message[data-v-fb9e4dc1]{color:#fffc;text-shadow:0 1px 2px rgba(0,0,0,.5)}.stream-chat.inside-player .icon-circle-outer[data-v-fb9e4dc1]{background-color:#ffffff0d;backdrop-filter:blur(8px)}.stream-chat.inside-player .icon-circle-inner[data-v-fb9e4dc1]{background-color:#ffffff1a;color:#fffc}.message-wrapper[data-v-fb9e4dc1]{display:flex;gap:8px;align-items:flex-start;justify-content:flex-start}.message-wrapper.own-message[data-v-fb9e4dc1]{flex-direction:row;justify-content:flex-start}.message-avatar[data-v-fb9e4dc1]{flex-shrink:0}.message-content[data-v-fb9e4dc1]{display:flex;flex-direction:column;gap:4px;max-width:95%;width:fit-content;align-items:flex-start}.own-message .message-content[data-v-fb9e4dc1]{align-items:flex-start}.message-sender[data-v-fb9e4dc1]{font-size:12px;font-weight:600;color:#666;display:flex;align-items:center;gap:6px}.stream-chat.inside-player .message-sender[data-v-fb9e4dc1]{color:#fff}.host-tag[data-v-fb9e4dc1]{background:#5773ff;color:#fff;font-size:10px;font-weight:600;padding:2px 6px;border-radius:8px;text-transform:uppercase;letter-spacing:.5px}.stream-chat.inside-player .host-tag[data-v-fb9e4dc1]{background:#5773ffe6;backdrop-filter:blur(4px)}.message-bubble[data-v-fb9e4dc1]{background:#f8f9fa;padding:8px 12px;overflow-wrap:break-word;word-break:normal;width:fit-content;border:1px solid #e9ecef;border-radius:16px;box-shadow:0 1px 2px #0000000d}.own-message .message-bubble[data-v-fb9e4dc1]{background:#e3f2fd;border-color:#bbdefb}.stream-chat.inside-player .message-bubble[data-v-fb9e4dc1]{background:#ffffff26;padding:8px 12px;border:2px solid rgba(255,255,255,.2);width:fit-content;min-width:60px}.stream-chat.inside-player .own-message .message-bubble[data-v-fb9e4dc1]{background:#e3f2fd33;border-color:#ffffff4d}.bubble-rounded[data-v-fb9e4dc1]{border-radius:16px}.bubble-square[data-v-fb9e4dc1]{border-radius:4px}.bubble-minimal[data-v-fb9e4dc1]{border-radius:0;background:transparent;padding:4px 0}.message-text[data-v-fb9e4dc1]{margin:0;line-height:1.5;font-size:16px;color:#333;text-align:left}.message-text.preserve-whitespace[data-v-fb9e4dc1]{white-space:pre-wrap}.message-attachment-container[data-v-fb9e4dc1]{margin:8px 0}.own-message .message-text[data-v-fb9e4dc1]{text-align:left}.stream-chat.inside-player .message-text[data-v-fb9e4dc1]{color:#fff;text-align:left;text-shadow:none}.stream-chat.inside-player .own-message .message-text[data-v-fb9e4dc1]{text-align:left}.message-timestamp[data-v-fb9e4dc1]{font-size:11px;opacity:.5;color:#666}.message-timestamp.inline[data-v-fb9e4dc1]{font-size:11px;opacity:.6;color:#999;font-weight:400}.stream-chat.inside-player .message-timestamp[data-v-fb9e4dc1]{color:#fff}.stream-chat.inside-player .message-timestamp.inline[data-v-fb9e4dc1]{color:#ffffffb3}.message-attachment-container[data-v-fb9e4dc1]{width:100%}.message-attachment[data-v-fb9e4dc1]{border-radius:8px;overflow:hidden}.image-attachment[data-v-fb9e4dc1]{cursor:pointer;max-width:300px}.attachment-preview-image[data-v-fb9e4dc1]{width:100%;height:auto;max-height:300px;object-fit:cover;display:block;border-radius:8px}.video-attachment[data-v-fb9e4dc1]{max-width:400px}.attachment-preview-video[data-v-fb9e4dc1]{width:100%;height:auto;max-height:300px;border-radius:8px;background:#000}.document-attachment[data-v-fb9e4dc1]{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px;background:#f8f9fa;border:1px solid #e5e5e5;border-radius:8px}.stream-chat.inside-player .document-attachment[data-v-fb9e4dc1]{background:#ffffff1a;border-color:#fff3}.attachment-info[data-v-fb9e4dc1]{display:flex;align-items:center;gap:8px;flex:1;min-width:0}.attachment-details[data-v-fb9e4dc1]{display:flex;flex-direction:column;min-width:0;text-align:left}.own-message .attachment-details[data-v-fb9e4dc1]{text-align:left}.attachment-name[data-v-fb9e4dc1]{font-size:14px;font-weight:500;color:#333;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.stream-chat.inside-player .attachment-name[data-v-fb9e4dc1]{color:#fff}.attachment-size[data-v-fb9e4dc1]{font-size:12px;color:#6c757d;margin-top:2px}.stream-chat.inside-player .attachment-size[data-v-fb9e4dc1]{color:#ffffffb3}.stream-chat.inside-player .attachment-details[data-v-fb9e4dc1],.stream-chat.inside-player .own-message .attachment-details[data-v-fb9e4dc1]{text-align:left}.download-button[data-v-fb9e4dc1]{flex-shrink:0;width:36px;height:36px;background:#fff;border:1px solid #e5e5e5;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#6c757d;transition:all .2s}.download-button[data-v-fb9e4dc1]:hover{background:#f8f9fa;color:#495057;transform:scale(1.05)}.stream-chat.inside-player .download-button[data-v-fb9e4dc1]{background:#ffffff1a;border-color:#ffffff4d;color:#fff}.stream-chat.inside-player .download-button[data-v-fb9e4dc1]:hover{background:#fff3}.input-container[data-v-fb9e4dc1]{display:flex;flex-direction:column;gap:8px;padding:12px;background:#fff;border:1px solid #e5e5e5;border-radius:12px;margin:16px}.stream-chat.inside-player .input-container[data-v-fb9e4dc1]{flex-direction:row;gap:8px;padding:12px;background:transparent;border:none;border-radius:0;margin:0;border-top:1px solid rgba(255,255,255,.1)}.input-wrapper[data-v-fb9e4dc1]{flex:1;display:flex;position:relative}.buttons-row[data-v-fb9e4dc1]{display:flex;justify-content:space-between;align-items:center}.icons-group[data-v-fb9e4dc1]{display:flex;align-items:center}.icons-group .attachment-button[data-v-fb9e4dc1],.icons-group .emoji-button[data-v-fb9e4dc1]{width:36px;height:36px}.message-input[data-v-fb9e4dc1]{flex:1;background:#f0f0f0;border:1px solid #d1d5db;transition:border-color .2s,box-shadow .2s;border:none;padding:0;color:#333;font-size:14px;outline:none;transition:all .2s}.message-input.standalone[data-v-fb9e4dc1]{width:100%;border:none;border-radius:12px;padding:12px 16px;min-height:44px;max-height:120px;box-sizing:border-box;resize:none;font-family:inherit;line-height:1.4;overflow-y:auto;scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.2) transparent}.message-input.standalone[data-v-fb9e4dc1]::-webkit-scrollbar{width:4px}.message-input.standalone[data-v-fb9e4dc1]::-webkit-scrollbar-track{background:transparent}.message-input.standalone[data-v-fb9e4dc1]::-webkit-scrollbar-thumb{background:#0003;border-radius:2px}.message-input.standalone[data-v-fb9e4dc1]::-webkit-scrollbar-thumb:hover{background:#0000004d}.stream-chat.inside-player .message-input[data-v-fb9e4dc1]{background:#ffffff1a;border:1px solid rgba(255,255,255);border-radius:8px;padding:8px 12px;color:#fff}.message-input[data-v-fb9e4dc1]:focus{outline:none}.message-input.standalone[data-v-fb9e4dc1]:focus{background:#f0f0f0}.stream-chat.inside-player .message-input[data-v-fb9e4dc1]:focus{background:#ffffff26;border-color:#ffffff4d}.message-input[data-v-fb9e4dc1]::placeholder{color:#999}.stream-chat.inside-player .message-input[data-v-fb9e4dc1]::placeholder{color:#fff}.message-input[data-v-fb9e4dc1]:disabled{opacity:.5;cursor:not-allowed}.attachment-button[data-v-fb9e4dc1],.emoji-button[data-v-fb9e4dc1],.send-button[data-v-fb9e4dc1]{background:transparent;border:none;color:#6c757d;cursor:pointer;padding:8px;border-radius:8px;transition:all .2s;display:flex;align-items:center;justify-content:center}.attachment-button[data-v-fb9e4dc1]:hover,.emoji-button[data-v-fb9e4dc1]:hover{background:#0000000d;color:#495057}.stream-chat.inside-player .attachment-button[data-v-fb9e4dc1],.stream-chat.inside-player .emoji-button[data-v-fb9e4dc1],.stream-chat.inside-player .send-button[data-v-fb9e4dc1]{color:#fff}.stream-chat.inside-player .attachment-button[data-v-fb9e4dc1]:hover,.stream-chat.inside-player .emoji-button[data-v-fb9e4dc1]:hover,.stream-chat.inside-player .send-button[data-v-fb9e4dc1]:hover:not(:disabled){background:#ffffff1a}.attachment-button[data-v-fb9e4dc1]:disabled,.emoji-button[data-v-fb9e4dc1]:disabled,.send-button[data-v-fb9e4dc1]:disabled{opacity:.5;cursor:not-allowed}.send-button[data-v-fb9e4dc1]{background:#5773ff;color:#fff;width:36px;height:36px;border-radius:12px}.send-button[data-v-fb9e4dc1]:hover:not(:disabled){background:#4361ee}.stream-chat.inside-player .send-button[data-v-fb9e4dc1]{background:#0084ff;color:#fff;width:36px;height:36px}.stream-chat.inside-player .send-button[data-v-fb9e4dc1]:hover:not(:disabled){background:#0073e6}.stream-chat.inside-player .input-wrapper .attachment-button[data-v-fb9e4dc1]{position:static;margin-right:8px}.stream-chat.inside-player[data-v-fb9e4dc1]{position:absolute;bottom:0;left:0;right:0;height:40%;max-height:400px;z-index:50}.stream-chat.inside-player .message-list[data-v-fb9e4dc1]{background:transparent;padding:12px 16px;max-height:calc(100% - 60px);mask:linear-gradient(to bottom,transparent 0%,black 10%,black 100%);-webkit-mask:linear-gradient(to bottom,transparent 0%,black 10%,black 100%)}.stream-chat.inside-player .message-wrapper.own-message[data-v-fb9e4dc1]{flex-direction:row}.stream-chat.inside-player .own-message .message-content[data-v-fb9e4dc1]{align-items:flex-start}.stream-chat.inside-player .message-content[data-v-fb9e4dc1]{width:auto}.file-preview[data-v-fb9e4dc1]{display:flex;align-items:center;gap:12px;background:#f0f2f5;border-radius:8px;width:100%;padding:12px;box-sizing:border-box}.file-icon[data-v-fb9e4dc1]{flex-shrink:0;width:40px;height:40px;background:#e9ecef;border-radius:8px;display:flex;align-items:center;justify-content:center;color:#6c757d}.file-preview-thumbnail[data-v-fb9e4dc1]{flex-shrink:0;width:40px;height:40px;border-radius:8px;overflow:hidden}.file-preview-thumbnail img[data-v-fb9e4dc1]{width:100%;height:100%;object-fit:cover}.file-info[data-v-fb9e4dc1]{flex:1;min-width:0}.file-name[data-v-fb9e4dc1]{font-size:14px;font-weight:500;color:#333;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.file-size[data-v-fb9e4dc1]{font-size:12px;color:#6c757d;margin-top:2px}.file-remove-button[data-v-fb9e4dc1]{flex-shrink:0;width:32px;height:32px;background:transparent;border:none;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#6c757d;transition:all .2s}.file-remove-button[data-v-fb9e4dc1]:hover:not(:disabled){background:#0000000d;color:#dc3545}.file-remove-button[data-v-fb9e4dc1]:disabled{opacity:.5;cursor:not-allowed}.progress-ring[data-v-fb9e4dc1]{animation:rotate-fb9e4dc1 2s linear infinite}.progress-ring-circle[data-v-fb9e4dc1]{transition:stroke-dasharray .3s ease}@keyframes rotate-fb9e4dc1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.loading-more-indicator[data-v-fb9e4dc1]{display:flex;align-items:center;justify-content:center;gap:8px;padding:16px;margin-bottom:8px;animation:fadeInDown-fb9e4dc1 .3s ease-out}.loading-spinner[data-v-fb9e4dc1]{width:16px;height:16px;border:2px solid #e5e5e5;border-top:2px solid #5773ff;border-radius:50%;animation:spin-fb9e4dc1 1s linear infinite}.loading-text[data-v-fb9e4dc1]{font-size:12px;color:#666;font-weight:500}.stream-chat.inside-player .loading-text[data-v-fb9e4dc1]{color:#fffc}.stream-chat.inside-player .loading-spinner[data-v-fb9e4dc1]{border-color:#ffffff4d;border-top-color:#fff}.no-more-indicator[data-v-fb9e4dc1]{display:flex;align-items:center;justify-content:center;padding:12px;margin-bottom:8px;animation:fadeInDown-fb9e4dc1 .3s ease-out}.no-more-text[data-v-fb9e4dc1]{font-size:11px;color:#999;text-align:center}.stream-chat.inside-player .no-more-text[data-v-fb9e4dc1]{color:#fff9}.initial-loading-bottom[data-v-fb9e4dc1]{padding:16px;animation:slideInFromBottom-fb9e4dc1 .4s ease-out;background:#00000003}.message-skeleton[data-v-fb9e4dc1]{display:flex;gap:8px;align-items:flex-start;margin-bottom:16px;animation:pulse-fb9e4dc1 1.5s ease-in-out infinite}.skeleton-avatar[data-v-fb9e4dc1]{width:32px;height:32px;border-radius:50%;background:linear-gradient(90deg,#f0f0f0 25%,#e0e0e0,#f0f0f0 75%);background-size:200% 100%;animation:shimmer-fb9e4dc1 1.5s infinite}.skeleton-content[data-v-fb9e4dc1]{flex:1;display:flex;flex-direction:column;gap:6px;max-width:70%}.skeleton-name[data-v-fb9e4dc1]{width:80px;height:12px;border-radius:6px;background:linear-gradient(90deg,#f0f0f0 25%,#e0e0e0,#f0f0f0 75%);background-size:200% 100%;animation:shimmer-fb9e4dc1 1.5s infinite}.skeleton-text[data-v-fb9e4dc1]{height:14px;border-radius:7px;background:linear-gradient(90deg,#f0f0f0 25%,#e0e0e0,#f0f0f0 75%);background-size:200% 100%;animation:shimmer-fb9e4dc1 1.5s infinite}.skeleton-text[data-v-fb9e4dc1]:not(.short){width:100%}.skeleton-text.short[data-v-fb9e4dc1]{width:60%}.stream-chat.inside-player .initial-loading-bottom[data-v-fb9e4dc1]{background:#ffffff0d;padding:8px 16px}.stream-chat.inside-player .message-skeleton[data-v-fb9e4dc1]{margin-bottom:8px}.stream-chat.inside-player .skeleton-avatar[data-v-fb9e4dc1],.stream-chat.inside-player .skeleton-name[data-v-fb9e4dc1],.stream-chat.inside-player .skeleton-text[data-v-fb9e4dc1]{background:linear-gradient(90deg,#ffffff1a 25%,#fff3,#ffffff1a 75%);background-size:200% 100%}.new-message-notification[data-v-fb9e4dc1]{position:absolute;bottom:180px;left:50%;transform:translate(-50%);background:#5773ff;color:#fff;border:none;border-radius:24px;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;padding:6px 10px;box-shadow:0 4px 12px #5773ff4d;transition:all .3s cubic-bezier(.4,0,.2,1);z-index:10;min-width:120px}.new-message-notification[data-v-fb9e4dc1]:hover{transform:translate(-50%) translateY(-2px);box-shadow:0 6px 20px #5773ff66;background:#4361ee}.new-message-notification[data-v-fb9e4dc1]:active{transform:translate(-50%) translateY(0)}.new-message-text[data-v-fb9e4dc1]{font-size:13px;font-weight:500}.stream-chat.inside-player .new-message-notification[data-v-fb9e4dc1]{background:#000c;backdrop-filter:blur(10px);box-shadow:0 4px 12px #0006;bottom:80px}.stream-chat.inside-player .new-message-notification[data-v-fb9e4dc1]:hover{background:#000000e6;box-shadow:0 6px 20px #00000080}.scroll-to-bottom-button[data-v-fb9e4dc1]{position:absolute;bottom:140px;right:16px;width:48px;height:48px;background:#5773ff;color:#fff;border:none;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 12px #5773ff4d;transition:all .3s cubic-bezier(.4,0,.2,1);z-index:10}.scroll-to-bottom-button[data-v-fb9e4dc1]:hover{transform:translateY(-2px);box-shadow:0 6px 20px #5773ff66}.scroll-to-bottom-button[data-v-fb9e4dc1]:active{transform:translateY(0)}.scroll-to-bottom-button.inside-player[data-v-fb9e4dc1]{background:#000000b3;backdrop-filter:blur(10px);box-shadow:0 4px 12px #0000004d}.scroll-to-bottom-button.inside-player[data-v-fb9e4dc1]:hover{background:#000c;box-shadow:0 6px 20px #0006}.scroll-button-enter-active[data-v-fb9e4dc1],.scroll-button-leave-active[data-v-fb9e4dc1]{transition:all .3s cubic-bezier(.4,0,.2,1)}.scroll-button-enter-from[data-v-fb9e4dc1],.scroll-button-leave-to[data-v-fb9e4dc1]{opacity:0;transform:translateY(20px) scale(.8)}.new-message-notification-enter-active[data-v-fb9e4dc1],.new-message-notification-leave-active[data-v-fb9e4dc1]{transition:all .3s cubic-bezier(.4,0,.2,1)}.new-message-notification-enter-from[data-v-fb9e4dc1],.new-message-notification-leave-to[data-v-fb9e4dc1]{opacity:0;transform:translate(-50%) translateY(20px) scale(.9)}@keyframes spin-fb9e4dc1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes shimmer-fb9e4dc1{0%{background-position:-200% 0}to{background-position:200% 0}}@keyframes fadeIn-fb9e4dc1{0%{opacity:0}to{opacity:1}}@keyframes fadeInDown-fb9e4dc1{0%{opacity:0;transform:translateY(-10px)}to{opacity:1;transform:translateY(0)}}@keyframes pulse-fb9e4dc1{0%,to{opacity:1}50%{opacity:.7}}@keyframes bounce-fb9e4dc1{0%,20%,53%,80%,to{transform:translateZ(0)}40%,43%{transform:translate3d(0,-8px,0)}70%{transform:translate3d(0,-4px,0)}90%{transform:translate3d(0,-2px,0)}}@media (max-width: 768px){.message-list[data-v-fb9e4dc1]{padding:12px}.message-content[data-v-fb9e4dc1]{max-width:85%}.input-container[data-v-fb9e4dc1]{padding:8px}.stream-chat.inside-player[data-v-fb9e4dc1]{height:50%;max-height:300px}.image-attachment[data-v-fb9e4dc1],.video-attachment[data-v-fb9e4dc1]{max-width:100%}.attachment-preview-image[data-v-fb9e4dc1],.attachment-preview-video[data-v-fb9e4dc1]{max-height:200px}.document-attachment[data-v-fb9e4dc1]{padding:10px}.attachment-name[data-v-fb9e4dc1]{font-size:13px}.scroll-to-bottom-button[data-v-fb9e4dc1]{width:44px;height:44px;bottom:70px;right:12px}.loading-more-indicator[data-v-fb9e4dc1],.initial-loading[data-v-fb9e4dc1]{padding:12px}}.attendee-player[data-v-0270311a]{position:relative;width:100%;height:100%;background-color:var(--299d9c90)}.stream-video[data-v-0270311a]{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:var(--11b25813);cursor:pointer;z-index:1}.stream-video.hidden[data-v-0270311a]{display:none}.screen-share-video[data-v-0270311a]{position:absolute;inset:0;width:100%;height:100%;object-fit:var(--11b25813);background-color:var(--299d9c90);z-index:2}.floating-video-container[data-v-0270311a]{width:200px;height:150px;background-color:var(--299d9c90);border-radius:8px;overflow:hidden;box-shadow:0 4px 12px #0006;border:2px solid rgba(255,255,255,.7);z-index:60}@media (max-width: 768px){.floating-video-container[data-v-0270311a]{width:120px;height:90px}}.floating-video[data-v-0270311a]{width:100%;height:100%;object-fit:cover}.loading-overlay[data-v-0270311a],.no-stream-overlay[data-v-0270311a]{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;background:#000000b3;gap:16px;z-index:20}.host-avatar-placeholder[data-v-0270311a]{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#1a1a1afa,#282828f2)}.spinner[data-v-0270311a]{width:20px;height:20px;border:2px solid rgba(255,255,255,.2);border-radius:50%;border-top-color:#fff;animation:spin-0270311a 1s cubic-bezier(.5,0,.5,1) infinite;margin-bottom:10px}@keyframes spin-0270311a{to{transform:rotate(360deg)}}.loading-text[data-v-0270311a]{font-size:16px;font-weight:600;color:#fff;text-align:center;line-height:1.5;padding:0 20px;max-width:400px;text-shadow:0 2px 4px rgba(0,0,0,.3);animation:fadeIn-0270311a .5s ease-out;margin:0}@keyframes fadeIn-0270311a{0%{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}.stream-info-overlay[data-v-0270311a]{position:absolute;inset:0;pointer-events:none;z-index:100}.status-bar[data-v-0270311a]{position:absolute;top:16px;right:16px;display:flex;gap:8px;pointer-events:auto}.play-pause-button[data-v-0270311a]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:60px;height:60px;background:none;border:none;display:flex;align-items:center;justify-content:center;cursor:pointer;pointer-events:auto;transition:all .2s ease;opacity:1}.play-pause-button[data-v-0270311a]:hover{transform:translate(-50%,-50%) scale(1.1)}.play-pause-button[data-v-0270311a]:active{transform:translate(-50%,-50%) scale(.95);transition:all .1s ease}.play-pause-button.playing[data-v-0270311a]{opacity:0;pointer-events:none}.video-container:hover .play-pause-button.playing[data-v-0270311a],.video-container[data-v-0270311a]:hover .attendee-control-bar{opacity:1;pointer-events:auto}@media (max-width: 768px){.status-bar[data-v-0270311a]{top:8px;right:8px}.play-pause-button[data-v-0270311a]{width:48px;height:48px}.loading-text[data-v-0270311a]{padding:0 16px}}@media (hover: none){.play-pause-button.playing[data-v-0270311a]{opacity:0;transition:opacity .3s ease 1s}.video-container:active .play-pause-button.playing[data-v-0270311a]{opacity:1;transition:opacity .1s ease}[data-v-0270311a] .attendee-control-bar{opacity:1;pointer-events:auto}}.attendee-control-bar[data-v-c373cbf1]{position:absolute;bottom:0;left:0;right:0;background:var(--856235fc);backdrop-filter:var(--a8dd41ca);opacity:1;transition:opacity .3s ease;pointer-events:none;z-index:200;transform:translateY(0)}.controls-container[data-v-c373cbf1]{display:flex;justify-content:space-between;align-items:center}.controls-left[data-v-c373cbf1],.controls-right[data-v-c373cbf1]{display:flex;align-items:center;gap:var(--30dc32a8)}.control-button[data-v-c373cbf1]{width:var(--45bbe64e);height:var(--45bbe64e);border-radius:4px;background:var(--28fbfe66);border:none;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:all .2s ease;backdrop-filter:blur(10px);margin:4px 2px}.control-button[data-v-c373cbf1]:hover{background:var(--011747ec);transform:var(--6e512c7d);border-radius:var(--f48da108);border:var(--e5d06a3c)}.control-button[data-v-c373cbf1]:active{background:var(--bf7583c8);transform:var(--15dd69b5);border-radius:var(--1611be08);border:var(--ff6e2d3c)}.volume-control[data-v-c373cbf1]{display:flex;align-items:center;gap:var(--30dc32a8)}.volume-slider[data-v-c373cbf1]{width:0;height:var(--1cd2c70c);-webkit-appearance:none;appearance:none;background:var(--1ca8b846);outline:none;border-radius:var(--32c3ad37);cursor:pointer;transition:width .3s ease,opacity .3s ease;opacity:0;margin:0}.volume-control:hover .volume-slider[data-v-c373cbf1]{width:60px;opacity:1}.volume-slider[data-v-c373cbf1]::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:var(--7711a4dd);height:var(--0a4cf084);background:var(--13ee4626);border-radius:var(--d6215ec8);cursor:pointer;transition:transform .1s ease;box-shadow:var(--26fdc13a)}.volume-slider[data-v-c373cbf1]::-webkit-slider-thumb:hover{transform:scale(1.2)}.volume-slider[data-v-c373cbf1]::-moz-range-thumb{width:var(--7711a4dd);height:var(--0a4cf084);background:var(--13ee4626);border-radius:var(--d6215ec8);cursor:pointer;border:none;transition:transform .1s ease;box-shadow:var(--26fdc13a)}.volume-slider[data-v-c373cbf1]::-moz-range-thumb:hover{transform:scale(1.2)}@media (max-width: 768px){.attendee-control-bar[data-v-c373cbf1]{opacity:1;pointer-events:auto}.volume-slider[data-v-c373cbf1]{width:0}.volume-control:hover .volume-slider[data-v-c373cbf1]{width:50px}}.live-indicator[data-v-c373cbf1]{display:flex;align-items:center;margin-left:8px;pointer-events:none}@media (hover: none){.attendee-control-bar[data-v-c373cbf1]{opacity:1;pointer-events:auto}.volume-slider[data-v-c373cbf1]{width:50px;opacity:1}}')),document.head.appendChild(a)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
var ya = Object.defineProperty, ga = Object.defineProperties;
var Sa = Object.getOwnPropertyDescriptors;
var Bt = Object.getOwnPropertySymbols;
var ba = Object.prototype.hasOwnProperty, ka = Object.prototype.propertyIsEnumerable;
var At = (W, h, f) => h in W ? ya(W, h, { enumerable: !0, configurable: !0, writable: !0, value: f }) : W[h] = f, t = (W, h) => {
  for (var f in h || (h = {}))
    ba.call(h, f) && At(W, f, h[f]);
  if (Bt)
    for (var f of Bt(h))
      ka.call(h, f) && At(W, f, h[f]);
  return W;
}, pt = (W, h) => ga(W, Sa(h));
var z = (W, h, f) => new Promise((e, S) => {
  var N = (x) => {
    try {
      y(f.next(x));
    } catch (R) {
      S(R);
    }
  }, d = (x) => {
    try {
      y(f.throw(x));
    } catch (R) {
      S(R);
    }
  }, y = (x) => x.done ? e(x.value) : Promise.resolve(x.value).then(N, d);
  y((f = f.apply(W, h)).next());
});
import { ref as k, watchEffect as rt, computed as a, defineComponent as Ye, provide as lt, onMounted as ut, createElementBlock as v, openBlock as r, renderSlot as qe, onUnmounted as _t, withModifiers as Je, normalizeStyle as m, normalizeClass as Ce, createCommentVNode as E, createElementVNode as o, inject as it, createVNode as X, toDisplayString as de, unref as s, useCssVars as gt, watch as $e, withDirectives as ct, createBlock as be, vShow as yt, withCtx as Ae, TransitionGroup as wa, Fragment as Ve, renderList as st, nextTick as kt, createTextVNode as Ca, Transition as Lt, withKeys as Rt, vModelText as $t, shallowRef as wt } from "vue";
import { u as dt, a as Et, b as Yt, C as pe, c as zt, d as Xt, e as Gt, f as xa, g as Ta, h as _a, O as Ea, i as za, j as Ma, A as Mt, P as Kt, k as tt, l as Ia, m as Pa, n as Ba, o as Aa, p as La, q as Ra, r as $a, s as Fa, N as Da } from "./useChatPagination-CkAvHsHC.js";
import { C as Ft, A as ja, S as Na, V as Dt, o as Va, R as Qe, P as jt, T as ft } from "./live-vendor-BylJtbi3.js";
import { a as Oa, A as Nt, j as Ha, L as Ct } from "./index-BKMcmhwk.js";
import { _ as Xe } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { u as St } from "./useResponsiveContainer-Dd7tfGkJ.js";
import { e as Vt, h as Ot, i as Ua, l as Ht, k as Wa, d as Ya, _ as Xa, a as xt, f as Ga, b as Tt, g as Ut, j as Wt } from "./SpeakerIcon.vue_vue_type_script_setup_true_lang-B7QhZ13r.js";
import { _ as Ka, c as Qt, b as Jt, d as Qa, e as Ja, a as qa } from "./VolumeMuteIcon.vue_vue_type_script_setup_true_lang-C85Cvqdw.js";
function Za(W = {}) {
  const {
    autoPublishCamera: h = !0,
    autoPublishMicrophone: f = !0,
    skipDeviceManagement: e = !1
  } = W, { connectionState: S, disconnect: N } = dt(), {
    isCameraEnabled: d,
    isMicrophoneEnabled: y,
    isScreenShareEnabled: x,
    setCameraEnabled: R,
    setMicrophoneEnabled: M,
    setScreenShareEnabled: b,
    toggleCamera: D,
    toggleMicrophone: g,
    toggleScreenShare: K
  } = Et(), ee = e ? null : Yt({ skipAutoEnumeration: !1 }), { switchVideoDevice: n, switchAudioInputDevice: V, switchAudioOutputDevice: O } = ee || {
    switchVideoDevice: () => z(this, null, function* () {
      throw new Error("Device management disabled");
    }),
    switchAudioInputDevice: () => z(this, null, function* () {
      throw new Error("Device management disabled");
    }),
    switchAudioOutputDevice: () => z(this, null, function* () {
      throw new Error("Device management disabled");
    })
  }, P = k(!1);
  return rt(() => {
    S.value === pe.Disconnected && P.value && (P.value = !1);
  }), {
    // State
    isActive: P,
    connectionState: S,
    // Actions
    start: (H) => z(this, null, function* () {
      if (!P.value)
        try {
          H != null && H.cameraDeviceId && (yield n(H.cameraDeviceId)), H != null && H.microphoneDeviceId && (yield V(H.microphoneDeviceId));
          const q = h && d.value, xe = f && y.value;
          q && (yield R(!0)), xe && (yield M(!0)), P.value = !0;
        } catch (q) {
          throw q;
        }
    }),
    stop: (H) => z(this, null, function* () {
      if (P.value)
        try {
          yield R(!1), yield M(!1), yield b(!1), yield N(H), P.value = !1;
        } catch (q) {
          throw q;
        }
    }),
    // Media controls
    isCameraEnabled: d,
    isMicrophoneEnabled: y,
    isScreenShareEnabled: x,
    toggleCamera: () => z(this, null, function* () {
      P.value && (yield D());
    }),
    toggleMicrophone: () => z(this, null, function* () {
      P.value && (yield g());
    }),
    toggleScreenShare: () => z(this, null, function* () {
      P.value && (yield K());
    }),
    // Direct access to base functions
    setCameraEnabled: R,
    setMicrophoneEnabled: M,
    setScreenShareEnabled: b,
    // Device switching
    switchVideoDevice: n,
    switchAudioInputDevice: V,
    switchAudioOutputDevice: O
  };
}
function en(W = {}) {
  const h = Za(W), { localParticipant: f } = zt(), e = Xt(), S = k("idle"), N = k("3"), d = k(0);
  let y = null;
  const x = () => {
    d.value = 0, y = window.setInterval(() => {
      d.value += 1;
    }, 1e3);
  }, R = () => {
    y && (clearInterval(y), y = null), d.value = 0;
  };
  return {
    // Stream-specific state
    streamState: S,
    streamDuration: d,
    countdownNumber: N,
    // State transition methods
    startConnecting: () => {
      S.value = "connecting";
    },
    setLive: () => {
      S.value = "live";
    },
    startCountdown: () => z(this, null, function* () {
      S.value = "countdown", N.value = "3", yield new Promise((n) => setTimeout(n, 1e3)), N.value = "2", yield new Promise((n) => setTimeout(n, 1e3)), N.value = "1", yield new Promise((n) => setTimeout(n, 1e3));
    }),
    showLiveMessage: () => z(this, null, function* () {
      S.value = "starting", yield new Promise((n) => setTimeout(n, 2e3)), S.value = "live";
    }),
    // Stream-specific actions
    startStream: (n) => z(this, null, function* () {
      if (S.value !== "live")
        try {
          yield h.start(n), S.value = "live", e.setLive(!0), e.setHost(f.value), x();
        } catch (V) {
          throw S.value = "idle", V;
        }
    }),
    stopStream: (n) => z(this, null, function* () {
      if (S.value === "live")
        try {
          S.value = "connecting", yield h.stop(n), e.setLive(!1), e.setHost(null), R();
        } catch (V) {
          throw V;
        }
    }),
    // Forward media controls from core host
    isCameraEnabled: h.isCameraEnabled,
    isMicrophoneEnabled: h.isMicrophoneEnabled,
    isScreenShareEnabled: h.isScreenShareEnabled,
    toggleCamera: h.toggleCamera,
    toggleMicrophone: h.toggleMicrophone,
    toggleScreenShare: h.toggleScreenShare
  };
}
function qt(W = {}) {
  const { autoConnect: h = !1 } = W, f = Gt(), { connectionState: e, disconnect: S } = dt(), { participants: N, getParticipantMetadata: d } = zt(), y = Xt(), x = k(Ft.Unknown), R = a(() => N.value.find((O) => {
    const P = O != null && O.metadata ? JSON.parse(O.metadata) : null;
    return P ? P.role === "host" : !1;
  }) || null), M = a(() => {
    var O;
    return d(((O = R.value) == null ? void 0 : O.identity) || "");
  }), b = a(() => e.value === pe.Connected), D = a(() => y.state.value.title), g = a(
    () => y.state.value.description
  ), K = a(() => y.attendeeCount.value), ee = a(() => y.isLive.value);
  rt(() => {
    y.setHost(R.value);
  }), rt(() => {
    const O = f.value;
    if (!O) return;
    const P = ($) => {
      x.value = $;
    };
    return O.on("connectionQualityChanged", P), () => {
      O.off("connectionQualityChanged", P);
    };
  });
  const n = () => z(this, null, function* () {
    if (!b.value)
      try {
        y.setRole("attendee");
      } catch (O) {
        throw O;
      }
  }), V = (O) => z(this, null, function* () {
    if (b.value)
      try {
        yield S(O), x.value = Ft.Unknown;
      } catch (P) {
        throw P;
      }
  });
  return h && rt(() => {
    e.value === pe.Disconnected && n();
  }), {
    // State
    host: R,
    hostMetadata: M,
    isConnected: b,
    connectionQuality: x,
    // Actions
    joinStream: n,
    leaveStream: V,
    // Stream info
    streamTitle: D,
    streamDescription: g,
    attendeeCount: K,
    isLive: ee
  };
}
const tn = { class: "stream-provider" }, an = /* @__PURE__ */ Ye({
  __name: "StreamProvider",
  props: {
    role: { default: "attendee" },
    title: { default: "" },
    description: { default: "" },
    token: {}
  },
  setup(W) {
    const h = W;
    xa({
      roomOptions: {
        adaptiveStream: {
          pixelDensity: "screen"
        },
        dynacast: !0,
        // Enhanced audio capture defaults for streaming
        audioCaptureDefaults: pt(t({}, Ea), { channelCount: 2 }),
        // stereo for immersive audio
        videoCaptureDefaults: {
          resolution: Dt.h1080.resolution
        },
        publishDefaults: {
          simulcast: !0,
          dtx: !0,
          red: !0,
          videoEncoding: Dt.h1080.encoding,
          screenShareEncoding: Na.h1080fps15.encoding,
          audioPreset: ja.musicHighQualityStereo
        }
      }
    });
    const f = Ta(h.role), e = Gt(), { connectionState: S } = dt(), N = a(() => S.value === "connected"), d = zt();
    lt("participants", d);
    const y = a(() => e.value && N.value && e.value.name || "");
    lt("assetId", y);
    const x = _a({
      skipMediaPermissions: h.role === "attendee"
    });
    return lt("streamControls", x), ut(() => {
      (h.title || h.description) && f.setStreamInfo(h.title, h.description), h.token && Oa(h.token);
    }), (R, M) => (r(), v("div", tn, [
      qe(R.$slots, "default", {}, void 0, !0)
    ]));
  }
}), Fo = /* @__PURE__ */ Xe(an, [["__scopeId", "data-v-82e0d6e5"]]), nn = /* @__PURE__ */ Ye({
  __name: "DraggableLayout",
  props: {
    initialX: { default: "0px" },
    initialY: { default: "0px" },
    constrainToParent: { type: Boolean, default: !0 },
    showHandle: { type: Boolean, default: !1 },
    handlePosition: { default: "top" },
    zIndex: {},
    absolute: { type: Boolean, default: !0 }
  },
  emits: ["drag-start", "drag-move", "drag-end", "position-change"],
  setup(W, { expose: h, emit: f }) {
    const e = W, S = f, N = k(null), d = k({
      x: e.initialX,
      y: e.initialY
    }), y = k(!1), x = k({ x: 0, y: 0 }), R = (g) => {
      if (!N.value) return;
      y.value = !0;
      const K = N.value.getBoundingClientRect();
      if (!N.value.parentElement) return;
      let n, V;
      if (g instanceof MouseEvent)
        n = g.clientX, V = g.clientY;
      else {
        const $ = g.touches[0];
        n = $.clientX, V = $.clientY, g.preventDefault();
      }
      const O = n - K.left, P = V - K.top;
      x.value = {
        x: O,
        y: P
      }, S("drag-start", {
        x: parseInt(d.value.x),
        y: parseInt(d.value.y)
      }), g instanceof MouseEvent ? (document.addEventListener("mousemove", M), document.addEventListener("mouseup", b)) : (document.addEventListener("touchmove", M, { passive: !1 }), document.addEventListener("touchend", b));
    }, M = (g) => {
      if (!y.value || !N.value) return;
      let K, ee;
      if (g instanceof MouseEvent)
        K = g.clientX, ee = g.clientY;
      else {
        const $ = g.touches[0];
        K = $.clientX, ee = $.clientY, g.preventDefault();
      }
      const n = N.value.parentElement;
      if (!n) return;
      const V = n.getBoundingClientRect();
      let O = K - V.left - x.value.x, P = ee - V.top - x.value.y;
      if (e.constrainToParent) {
        const $ = N.value.getBoundingClientRect(), B = 0, ke = V.width - $.width, J = 0, te = V.height - $.height;
        O = Math.max(B, Math.min(ke, O)), P = Math.max(J, Math.min(te, P));
      }
      d.value = {
        x: `${O}px`,
        y: `${P}px`
      }, S("drag-move", { x: O, y: P }), S("position-change", d.value);
    }, b = () => {
      y.value && (y.value = !1, S("drag-end", {
        x: parseInt(d.value.x),
        y: parseInt(d.value.y)
      }), document.removeEventListener("mousemove", M), document.removeEventListener("mouseup", b), document.removeEventListener("touchmove", M), document.removeEventListener("touchend", b));
    };
    return h({
      setPosition: (g, K) => {
        d.value = { x: g, y: K }, S("position-change", d.value);
      },
      position: d
    }), _t(() => {
      document.removeEventListener("mousemove", M), document.removeEventListener("mouseup", b), document.removeEventListener("touchmove", M), document.removeEventListener("touchend", b);
    }), (g, K) => (r(), v("div", {
      ref_key: "draggableLayout",
      ref: N,
      class: Ce(["draggable-layout", {
        dragging: y.value,
        "constrain-to-parent": g.constrainToParent
      }]),
      style: m({
        position: g.absolute ? "absolute" : "fixed",
        left: d.value.x,
        top: d.value.y,
        zIndex: g.zIndex,
        cursor: y.value ? "grabbing" : "grab"
      }),
      onMousedown: Je(R, ["stop"]),
      onTouchstart: Je(R, ["stop"])
    }, [
      g.showHandle ? (r(), v("div", {
        key: 0,
        class: Ce(["drag-handle", g.handlePosition])
      }, [
        qe(g.$slots, "handle", {}, () => [
          K[0] || (K[0] = o("div", { class: "default-handle" }, null, -1))
        ], !0)
      ], 2)) : E("", !0),
      qe(g.$slots, "default", {}, void 0, !0)
    ], 38));
  }
}), Zt = /* @__PURE__ */ Xe(nn, [["__scopeId", "data-v-065f0480"]]), on = /* @__PURE__ */ Ye({
  __name: "ViewersCount",
  props: {
    iconSize: { default: 14 },
    iconColor: { default: "#ffffff" },
    textColor: { default: "#ffffff" },
    backgroundColor: { default: "#1e2939" }
  },
  setup(W) {
    const h = W, f = it("participants"), { participantCount: e } = f, S = a(() => ({
      backgroundColor: h.backgroundColor
    })), N = a(() => ({
      color: h.textColor
    }));
    return (d, y) => (r(), v("div", {
      class: "viewer-count",
      style: m(S.value)
    }, [
      X(Ka, {
        size: d.iconSize,
        color: d.iconColor
      }, null, 8, ["size", "color"]),
      o("span", {
        class: "viewer-count-text",
        style: m(N.value)
      }, de(s(e) > 0 ? s(e) - 1 : 0), 5)
    ], 4));
  }
}), ea = /* @__PURE__ */ Xe(on, [["__scopeId", "data-v-66d9289a"]]), sn = /* @__PURE__ */ Ye({
  __name: "LiveBadge",
  props: {
    dotSize: { default: 8 },
    textSize: { default: 14 },
    backgroundColor: { default: "white" },
    textColor: { default: "#333333" },
    padding: { default: "6px 10px" },
    paused: { type: Boolean, default: !1 }
  },
  setup(W) {
    const h = W, f = a(() => ({
      backgroundColor: h.backgroundColor,
      padding: h.padding
    })), e = a(() => ({
      width: typeof h.dotSize == "number" ? `${h.dotSize}px` : h.dotSize,
      height: typeof h.dotSize == "number" ? `${h.dotSize}px` : h.dotSize
    })), S = a(() => ({
      fontSize: typeof h.textSize == "number" ? `${h.textSize}px` : h.textSize,
      color: h.textColor
    }));
    return (N, d) => (r(), v("div", {
      class: "live-badge",
      style: m(f.value)
    }, [
      o("span", {
        class: Ce(["live-dot", { paused: N.paused }]),
        style: m(e.value)
      }, null, 6),
      o("span", {
        class: "live-text",
        style: m(S.value)
      }, "LIVE", 4)
    ], 4));
  }
}), ta = /* @__PURE__ */ Xe(sn, [["__scopeId", "data-v-9875bbcf"]]), rn = { class: "video-container" }, ln = {
  key: 0,
  class: "view-placeholder"
}, cn = {
  key: 1,
  class: "permission-button-overlay"
}, un = { class: "permission-prompt-container" }, dn = { class: "permission-prompt-text" }, vn = {
  key: 3,
  class: "status-overlay"
}, mn = {
  key: 5,
  class: "loading-overlay"
}, pn = {
  key: 0,
  class: "spinner"
}, fn = {
  key: 1,
  class: "countdown-container"
}, hn = {
  key: 2,
  class: "message-container"
}, yn = { class: "connection-message" }, gn = /* @__PURE__ */ Ye({
  __name: "StreamHostPlayer",
  props: {
    hostId: {},
    hostName: {},
    hostAvatar: {},
    videoFit: { default: "cover" },
    backgroundColor: { default: "#000000" },
    borderRadius: { default: "12px" },
    hideLoadingSpinner: { type: Boolean, default: !1 }
  },
  emits: ["stream-ready", "device", "stream-started", "stream-ended", "error"],
  setup(W, { expose: h, emit: f }) {
    gt((_) => ({
      "0753c819": e.backgroundColor,
      dca35dcc: e.borderRadius,
      a8b58d16: Oe.value,
      d87e6076: _e.value,
      c1404386: Fe.value,
      69873144: Ge.value,
      "9710865c": e.videoFit
    })), lt("isInsidePlayerSlot", !0);
    const e = W, S = Et(), N = za(), d = f, { videoDevices: y, audioInputDevices: x } = Yt({ skipAutoEnumeration: !0 }), { connect: R, connectionState: M, transferLocalMediaToRoom: b, isConnected: D } = dt(), {
      streamState: g,
      countdownNumber: K,
      startConnecting: ee,
      setLive: n,
      startCountdown: V,
      showLiveMessage: O,
      startStream: P,
      stopStream: $
    } = en({
      // Disable auto-publish to prevent unwanted permission requests
      autoPublishCamera: !1,
      autoPublishMicrophone: !1,
      // Skip device management to prevent useMediaDevices() calls
      skipDeviceManagement: !0
    }), B = Ma({
      skipAutoEnable: !1,
      // Enable eager permissions for stream host
      enabledControls: ["camera", "microphone"]
      // Enable camera and microphone controls
    }), ke = k(null), J = a(() => D()), te = () => {
      if (J.value)
        try {
          return S;
        } catch (_) {
          return null;
        }
      return null;
    }, H = a(() => J.value ? S.isCameraEnabled.value : B.isCameraEnabled.value), q = a(() => J.value ? S.isScreenShareEnabled.value : B.isScreenShareEnabled.value), xe = a(() => J.value && S.localParticipant.value && S.localParticipant.value.isSpeaking || !1), ge = a(() => N.audioLevel.value), ye = k(null), re = k(null), le = k(null), ze = k(null), { containerWidth: ve } = St(ze, {
      debounceTime: 100
      // Quick response time
    }), Oe = a(() => Math.max(11, Math.min(16, ve.value * 0.018)) + "px"), _e = a(() => Math.max(6, Math.min(9, ve.value * 0.01)) + "px"), Fe = a(() => Math.max(80, Math.min(120, ve.value * 0.13)) + "px"), Ge = a(() => Math.max(24, Math.min(36, ve.value * 0.045)) + "px"), ne = k("Connecting to server..."), U = k(!0), ae = k(null), oe = k(null), se = k(null), j = k(!1), Ee = k(!1), we = a(() => {
      const _ = B.cameraPermission.value.state === "denied" || B.cameraPermission.value.state === "prompt", I = B.microphonePermission.value.state === "denied" || B.microphonePermission.value.state === "prompt";
      return _ || I;
    }), Me = a(() => {
      const _ = B.cameraPermission.value.state === "denied" || B.cameraPermission.value.state === "prompt", I = B.microphonePermission.value.state === "denied" || B.microphonePermission.value.state === "prompt";
      return _ && I ? "Allow camera and microphone" : _ ? "Allow camera" : I ? "Allow microphone" : "Allow media access";
    }), T = a(() => {
      const _ = B.cameraPermission.value.state === "denied" || B.cameraPermission.value.state === "prompt", I = B.microphonePermission.value.state === "denied" || B.microphonePermission.value.state === "prompt";
      return _ && I ? "Do you want people to see and hear you in the session?" : _ ? "Do you want people to see you in the session?" : I ? "Do you want people to hear you in the session?" : "Do you want to enable media access?";
    }), ue = () => {
      j.value = !1;
    }, Ie = () => {
      ue();
    }, He = () => z(this, null, function* () {
      j.value = !1, yield We();
    }), Le = () => {
      j.value = !0;
    }, fe = () => {
      var _, I;
      if (ye.value) {
        if (!H.value) {
          ye.value.srcObject && (ye.value.srcObject = null);
          return;
        }
        try {
          let w = null;
          if (J.value) {
            const Y = te();
            if ((I = (_ = Y == null ? void 0 : Y.cameraTrack) == null ? void 0 : _.value) != null && I.track) {
              const Q = Y.cameraTrack.value.track;
              w = new MediaStream(), "mediaStreamTrack" in Q ? w.addTrack(Q.mediaStreamTrack) : "id" in Q && "kind" in Q && w.addTrack(Q);
            }
          } else
            w = B.cameraStream.value;
          w && w.getTracks().length > 0 && (ye.value.srcObject = w, ye.value.onloadedmetadata = () => {
            var Y;
            (Y = ye.value) == null || Y.play().catch(
              (Q) => {
              }
            );
          });
        } catch (w) {
        }
      }
    }, Te = () => {
      var _, I;
      if (re.value) {
        if (!q.value) {
          re.value.srcObject && (re.value.srcObject = null);
          return;
        }
        try {
          let w = null;
          if (J.value) {
            const Y = te();
            if ((I = (_ = Y == null ? void 0 : Y.screenShareTrack) == null ? void 0 : _.value) != null && I.track) {
              const Q = Y.screenShareTrack.value.track;
              w = new MediaStream(), "mediaStreamTrack" in Q ? w.addTrack(Q.mediaStreamTrack) : "id" in Q && "kind" in Q && w.addTrack(Q);
            }
          } else
            w = B.screenShareStream.value;
          w && w.getTracks().length > 0 && (re.value.srcObject = w, re.value.onloadedmetadata = () => {
            var Y;
            (Y = re.value) == null || Y.play().catch(
              (Q) => {
              }
            );
          });
        } catch (w) {
        }
      }
    }, Pe = () => {
      var _, I;
      if (le.value) {
        if (!q.value || !H.value) {
          le.value.srcObject && (le.value.srcObject = null);
          return;
        }
        try {
          let w = null;
          if (J.value) {
            const Y = te();
            if ((I = (_ = Y == null ? void 0 : Y.cameraTrack) == null ? void 0 : _.value) != null && I.track) {
              const Q = Y.cameraTrack.value.track;
              w = new MediaStream(), "mediaStreamTrack" in Q ? w.addTrack(Q.mediaStreamTrack) : "id" in Q && "kind" in Q && w.addTrack(Q);
            }
          } else
            w = B.cameraStream.value;
          w && w.getTracks().length > 0 && (le.value.srcObject = w, le.value.onloadedmetadata = () => {
            var Y;
            (Y = le.value) == null || Y.play().catch(
              (Q) => {
              }
            );
          });
        } catch (w) {
        }
      }
    }, Ue = (_) => {
      d("error", new Error("Video playback error"));
    }, Ke = () => {
      var w, Y;
      let _, I;
      if (J.value) {
        const Q = te();
        if (Q) {
          const Ne = (w = Q.cameraTrack.value) == null ? void 0 : w.track, Re = (Y = Q.microphoneTrack.value) == null ? void 0 : Y.track;
          if (Ne && "getSettings" in Ne) {
            const he = Ne.getSettings();
            _ = he == null ? void 0 : he.deviceId;
          }
          if (Re && "getSettings" in Re) {
            const he = Re.getSettings();
            I = he == null ? void 0 : he.deviceId;
          }
        }
      } else
        _ = B.selectedCamera.value, I = B.selectedMicrophone.value;
      d("device", {
        camera: _,
        microphone: I,
        speaker: B.selectedSpeaker.value
      });
    }, Ze = () => {
      d("stream-ready", {
        hasCamera: y.value.length > 0,
        hasMicrophone: x.value.length > 0,
        selectedDevices: {
          camera: void 0,
          // Will be set by parent via controls
          microphone: void 0,
          // Will be set by parent via controls
          speaker: void 0
          // Will be set by parent via controls
        }
      });
    };
    $e(
      [
        () => S.isCameraEnabled.value,
        () => S.isScreenShareEnabled.value,
        () => S.cameraTrack.value,
        () => S.screenShareTrack.value
      ],
      () => {
        fe(), Te(), Pe(), Ke();
      }
    ), $e(
      [
        () => H.value,
        () => q.value,
        () => B.cameraStream.value,
        () => B.screenShareStream.value
      ],
      () => {
        fe(), Te(), Pe(), Ke();
      }
    );
    const De = (_, I) => z(this, null, function* () {
      if (ae.value = _, oe.value = I, g.value === "live" || g.value !== "idle")
        throw new Error("Already broadcasting or connecting");
      try {
        ee(), ne.value = "Connecting to server...", U.value = !0;
        const w = yield R({
          licenseId: ae.value,
          participantToken: oe.value
        });
        if (!w.canJoin) {
          ne.value = w.message || "Cannot join the session.", w.retryInSeconds ? (U.value = !0, setTimeout(() => {
            De(ae.value, oe.value);
          }, w.retryInSeconds * 1e3)) : U.value = !1;
          return;
        }
        ne.value = w.message || "Connecting to server...", yield V(), yield b(), yield P(), yield O(), d("stream-started"), fe(), Te(), Pe();
      } catch (w) {
        throw ne.value = w && typeof w == "object" && "message" in w ? w.message : "Failed to connect", U.value = !1, d(
          "error",
          w instanceof Error ? w : new Error("Failed to start stream")
        ), w;
      }
    }), We = () => z(this, null, function* () {
      if (g.value === "live")
        try {
          ne.value = "Ending stream...", U.value = !0, yield $({
            licenseId: ae.value,
            participantToken: oe.value
          }), d("stream-ended"), fe(), Te(), Pe(), ne.value = "This session has ended.", U.value = !1;
        } catch (_) {
          throw d(
            "error",
            _ instanceof Error ? _ : new Error("Failed to stop stream")
          ), _;
        }
    }), Z = () => {
      Se(), se.value = window.setTimeout(() => {
        je();
      }, 1 * 60 * 1e3);
    }, Se = () => {
      se.value && (clearTimeout(se.value), se.value = null);
    }, je = () => z(this, null, function* () {
      try {
        yield $({
          licenseId: ae.value,
          participantToken: oe.value
        }), ne.value = "Connection lost. Please refresh to restart.", U.value = !1, d("stream-ended"), d("error", new Error("Reconnection timeout"));
      } catch (_) {
      }
    });
    return ut(() => {
      Ze(), fe(), Te(), Pe();
    }), $e(
      () => S.isCameraEnabled.value,
      (_) => {
        setTimeout(() => {
          fe(), q.value && Pe();
        }, 500);
      }
    ), $e(
      () => M.value,
      (_, I) => {
        _ === pe.Reconnecting || _ === pe.SignalReconnecting ? (ee(), ne.value = "Reconnecting...", U.value = !0, Z()) : (I === pe.Reconnecting || I === pe.SignalReconnecting) && _ === pe.Connected && (Se(), n(), ne.value = "", U.value = !1);
      }
    ), _t(() => {
      Se(), g.value === "live" && We().catch(console.error);
    }), h({
      startStream: De,
      stopStream: Le
    }), (_, I) => (r(), v("div", {
      ref_key: "hostViewRef",
      ref: ze,
      class: "host-view"
    }, [
      o("div", rn, [
        o("video", {
          ref_key: "viewVideo",
          ref: ye,
          autoplay: "",
          muted: "",
          playsinline: "",
          class: Ce(["view-video", { hidden: q.value }])
        }, null, 2),
        ct(o("video", {
          ref_key: "screenShareVideo",
          ref: re,
          autoplay: "",
          muted: "",
          playsinline: "",
          class: "screen-share-view",
          onError: Ue
        }, null, 544), [
          [yt, q.value]
        ]),
        ct(X(s(Zt), {
          ref_key: "floatingVideoContainer",
          ref: ke,
          "initial-x": "16px",
          "initial-y": "16px",
          class: "floating-video-container"
        }, {
          default: Ae(() => [
            o("video", {
              ref_key: "floatingVideoElement",
              ref: le,
              autoplay: "",
              muted: "",
              playsinline: "",
              class: "floating-video"
            }, null, 512)
          ]),
          _: 1
        }, 512), [
          [yt, q.value && H.value]
        ]),
        !H.value && !q.value ? (r(), v("div", ln, [
          X(Mt, {
            name: _.hostName,
            image: _.hostAvatar,
            size: "medium",
            "is-speaking": xe.value,
            "audio-level": ge.value
          }, null, 8, ["name", "image", "is-speaking", "audio-level"])
        ])) : E("", !0),
        s(g) === "idle" && we.value ? (r(), v("div", cn, [
          o("div", un, [
            o("p", dn, de(T.value), 1),
            o("button", {
              class: "permission-button",
              onClick: I[0] || (I[0] = (w) => Ee.value = !0)
            }, [
              o("span", null, de(Me.value), 1)
            ])
          ])
        ])) : E("", !0),
        Ee.value ? (r(), be(Kt, {
          key: 2,
          "camera-permission": s(B).cameraPermission.value,
          "microphone-permission": s(B).microphonePermission.value,
          onClose: I[1] || (I[1] = (w) => Ee.value = !1)
        }, null, 8, ["camera-permission", "microphone-permission"])) : E("", !0),
        qe(_.$slots, "controls", {}, void 0, !0),
        qe(_.$slots, "chat", {}, void 0, !0),
        s(g) === "live" ? (r(), v("div", vn, [
          X(ta, {
            "dot-size": _e.value,
            "text-size": Oe.value
          }, null, 8, ["dot-size", "text-size"]),
          X(ea, { "icon-size": Oe.value }, null, 8, ["icon-size"])
        ])) : E("", !0),
        j.value ? (r(), v("div", {
          key: 4,
          class: "modal-overlay",
          onClick: Ie
        }, [
          o("div", {
            class: "modal-content",
            onClick: I[2] || (I[2] = Je(() => {
            }, ["stop"]))
          }, [
            o("div", { class: "modal-header" }, [
              I[4] || (I[4] = o("h3", { class: "modal-title" }, "End live stream?", -1)),
              o("button", {
                class: "modal-close",
                onClick: ue
              }, I[3] || (I[3] = [
                o("svg", {
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  o("path", {
                    d: "M18 6L6 18M6 6L18 18",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)
              ]))
            ]),
            I[5] || (I[5] = o("div", { class: "modal-body" }, [
              o("p", { class: "modal-message" }, " If you exit now while you're live, it will immediately end the broadcast. ")
            ], -1)),
            o("div", { class: "modal-actions" }, [
              o("button", {
                class: "modal-button cancel-button",
                onClick: ue
              }, " Cancel "),
              o("button", {
                class: "modal-button confirm-button",
                onClick: He
              }, " End live video ")
            ])
          ])
        ])) : E("", !0),
        s(g) !== "idle" && s(g) !== "live" ? (r(), v("div", mn, [
          s(g) === "connecting" && U.value && !_.hideLoadingSpinner ? (r(), v("div", pn)) : E("", !0),
          s(g) === "countdown" || s(g) === "starting" ? (r(), v("div", fn, [
            o("p", {
              class: Ce({
                "countdown-number": s(g) === "countdown",
                "live-message": s(g) === "starting"
              })
            }, de(s(g) === "countdown" ? s(K) : "You are now live!"), 3)
          ])) : E("", !0),
          s(g) === "connecting" ? (r(), v("div", hn, [
            o("p", yn, de(ne.value), 1)
          ])) : E("", !0)
        ])) : E("", !0)
      ])
    ], 512));
  }
}), Do = /* @__PURE__ */ Xe(gn, [["__scopeId", "data-v-9b5f6bbd"]]), Sn = ["data-control-size", "data-gap-size", "data-dropdown-width", "data-edge-offset"], bn = {
  key: 0,
  class: "permission-indicator",
  title: "Camera access denied"
}, kn = {
  key: 0,
  class: "permission-indicator",
  title: "Microphone access denied"
}, wn = {
  key: 0,
  class: "permission-indicator",
  title: "Screen sharing access denied"
}, Cn = {
  key: 4,
  class: "settings-container control-item"
}, xn = {
  key: 0,
  class: "controls-end"
}, Tn = { class: "dropdown-content" }, _n = { class: "select-wrapper" }, En = ["value"], zn = ["value"], Mn = { class: "select-wrapper" }, In = ["value"], Pn = ["value"], Bn = {
  key: 0,
  class: "mic-meter-wrapper"
}, An = { class: "select-wrapper" }, Ln = ["value"], Rn = ["value"], $n = /* @__PURE__ */ Ye({
  __name: "StreamHostControlBar",
  props: {
    embeddedPosition: { default: "bottom" },
    containerStyle: {},
    barBackgroundColor: { default: "none" },
    buttonStyle: {},
    activeButtonStyle: {},
    hoverButtonStyle: {},
    disabledButtonStyle: {},
    iconStyle: {},
    iconColor: { default: "white" },
    activeIconColor: { default: "#4285f4" },
    dropdownStyle: {},
    dropdownItemStyle: {},
    dropdownItemHoverStyle: {},
    dropdownBackgroundColor: { default: "rgba(32, 33, 36, 0.98)" },
    textStyle: {},
    textColor: { default: "white" },
    fontFamily: {},
    borderRadius: { default: "12px" },
    padding: {},
    boxShadow: {},
    backdropFilter: {},
    controls: { default: () => [] }
  },
  emits: ["camera", "microphone", "screen-share", "camera-flip", "device", "error"],
  setup(W, { expose: h, emit: f }) {
    gt((p) => ({
      "6afd1946": oe.value + "px",
      "066c35fc": ue.value ? se.value + "px" : "0",
      "2a46e11f": ue.value ? T.barBackgroundColor : "transparent",
      "3bf89cee": ue.value ? se.value * 0.6 + "px" : "0",
      "291af05f": ae.value + "px",
      "3e7510a3": j.value + "px",
      "6da17cdc": T.iconColor,
      faac76b0: T.textColor,
      "22bcfbfc": s(U) + "px",
      "54a8a166": we.value + "px",
      "3e72cac3": j.value + "px",
      "64500d76": T.dropdownBackgroundColor,
      "3611d5a9": se.value * 0.6 + "px",
      a30f1170: Ee.value + "px",
      "39f80043": oe.value * 0.7 + "px",
      "21e44974": T.dropdownBackgroundColor === "none" ? "transparent" : T.dropdownBackgroundColor,
      "664f7beb": se.value * 0.4 + "px",
      "48065b4b": se.value + "px",
      "02c67c36": j.value * 0.75 + "px",
      "7b1b86ce": s(U) * 0.7 + "px",
      "1e6e4708": Me.value * 0.5 + "px",
      "306cc12f": T.dropdownBackgroundColor === "none" ? "rgba(32, 33, 36, 0.95)" : T.dropdownBackgroundColor,
      "7a4a6546": T.barBackgroundColor === "none" ? "rgba(32, 33, 36, 0.95)" : T.barBackgroundColor,
      c3b90532: oe.value
    }));
    const e = k(!0), S = () => {
      e.value = !e.value;
    }, N = a(() => !e.value || T.controls.length <= 3 ? T.controls : T.controls.slice(0, 3)), d = it("streamControls"), {
      // Device lists
      videoDevices: y,
      audioInputDevices: x,
      audioOutputDevices: R,
      // Media states
      isCameraEnabled: M,
      isMicrophoneEnabled: b,
      isScreenShareEnabled: D,
      isScreenShareSupported: g,
      hasMultipleCameras: K,
      // Browser permission states
      cameraPermission: ee,
      microphonePermission: n,
      screenSharePermission: V,
      // Selected devices
      selectedCamera: O,
      selectedMicrophone: P,
      selectedSpeaker: $,
      // Streams
      cameraStream: B,
      microphoneStream: ke,
      screenShareStream: J,
      // Control methods
      toggleCamera: te,
      toggleMicrophone: H,
      toggleScreenShare: q,
      startCamera: xe,
      stopCamera: ge,
      startMicrophone: ye,
      stopMicrophone: re,
      startScreenShare: le,
      stopScreenShare: ze,
      // Device management
      handleDeviceChange: ve,
      handleCameraFlip: Oe
    } = d, _e = it("isInsidePlayerSlot", !1), Fe = k(null), Ge = k(null);
    ut(() => {
      if (Fe.value) {
        const p = Fe.value.parentElement;
        p && (Ge.value = p);
      }
    });
    const { containerWidth: ne, baseFontSize: U } = St(
      Ge,
      {
        baseSize: 16,
        // Base size at reference width
        referenceWidth: 800,
        // Width at which base size applies
        minSize: 12,
        // Minimum size
        maxSize: 20,
        // Maximum size
        debounceTime: 100
        // Quick response time
      }
    ), ae = a(() => {
      const A = 28 + 12 * (U.value - 12) / 8;
      return Math.max(28, Math.min(40, A));
    }), oe = a(() => {
      const A = 16 + 4 * (U.value - 12) / 8;
      return Math.max(16, Math.min(20, A));
    }), se = a(() => {
      const A = 16 + 4 * (U.value - 12) / 8;
      return Math.max(16, Math.min(20, A));
    }), j = a(() => {
      const A = 24 + 4 * (U.value - 12) / 8;
      return Math.max(24, Math.min(28, A));
    }), Ee = a(() => Math.min(280, Math.max(100, ne.value * 0.8))), we = a(() => {
      const nt = 8 + Math.min(ne.value, 1200) / 1200 * 8;
      return Math.max(8, Math.min(16, nt));
    }), Me = a(() => {
      const nt = 6 + Math.min(ne.value, 1200) / 1200 * 6;
      return Math.max(6, Math.min(12, nt));
    }), T = W;
    lt("controlsConfig", T.controls);
    const ue = a(() => T.barBackgroundColor !== "none"), Ie = a(() => T.embeddedPosition === "left" || T.embeddedPosition === "right"), He = a(() => _e), Le = a(() => t(t({
      backgroundColor: T.barBackgroundColor,
      padding: T.padding,
      borderRadius: T.borderRadius,
      boxShadow: T.boxShadow,
      backdropFilter: T.backdropFilter,
      fontFamily: T.fontFamily
    }, T.barBackgroundColor === "none" && !T.containerStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.25))"
    } : {}), T.containerStyle)), fe = a(() => t(t({}, T.barBackgroundColor === "none" && !T.buttonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), T.buttonStyle)), Te = a(() => t(t({}, T.barBackgroundColor === "none" && !T.activeButtonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), T.activeButtonStyle)), Pe = a(() => t({
      backgroundColor: T.dropdownBackgroundColor,
      borderRadius: T.borderRadius,
      boxShadow: T.boxShadow,
      fontFamily: T.fontFamily
    }, T.dropdownStyle)), Ue = a(() => t({
      color: T.textColor
    }, T.dropdownItemStyle)), Ke = a(() => t(t({
      color: T.textColor,
      fontFamily: T.fontFamily
    }, T.barBackgroundColor === "none" && !T.textStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), T.textStyle)), Ze = () => ee.value.state === "denied" ? "Camera access denied. Please allow camera access in browser settings." : M.value ? "Turn off camera" : "Turn on camera", De = () => n.value.state === "denied" ? "Microphone access denied. Please allow microphone access in browser settings." : b.value ? "Mute" : "Unmute", We = () => V.value.state === "denied" ? "Screen sharing access denied. Please allow screen sharing in browser settings." : g ? D ? "Stop sharing" : "Share screen" : "Screen sharing not supported on this device", Z = f, Se = k(!1), je = k(null), _ = k(!1), I = (p) => {
      p && p.stopPropagation(), Se.value = !Se.value;
    }, w = (p) => {
      je.value && !je.value.contains(p.target) && (Se.value = !1);
    }, Y = () => z(this, null, function* () {
      try {
        if (ee.value.state === "denied") {
          _.value = !0;
          return;
        }
        yield te(), Z("camera", M.value, B.value);
      } catch (p) {
        Z(
          "error",
          p instanceof Error ? p : new Error("Failed to toggle camera")
        );
      }
    }), Q = () => z(this, null, function* () {
      try {
        yield xe(), Z("camera", !0, B.value);
      } catch (p) {
        Z(
          "error",
          p instanceof Error ? p : new Error("Failed to start camera")
        );
      }
    }), Ne = () => {
      try {
        ge(), Z("camera", !1, null);
      } catch (p) {
        Z(
          "error",
          p instanceof Error ? p : new Error("Failed to stop camera")
        );
      }
    }, Re = () => z(this, null, function* () {
      try {
        if (n.value.state === "denied") {
          _.value = !0;
          return;
        }
        yield H(), Z("microphone", b.value, ke.value);
      } catch (p) {
        Z(
          "error",
          p instanceof Error ? p : new Error("Failed to toggle microphone")
        );
      }
    }), he = () => z(this, null, function* () {
      try {
        yield ye(), Z("microphone", !0, ke.value);
      } catch (p) {
        Z(
          "error",
          p instanceof Error ? p : new Error("Failed to start microphone")
        );
      }
    }), et = () => {
      try {
        re(), Z("microphone", !1, null);
      } catch (p) {
        Z(
          "error",
          p instanceof Error ? p : new Error("Failed to stop microphone")
        );
      }
    }, at = () => z(this, null, function* () {
      try {
        yield q(), Z("screen-share", D.value, J.value);
      } catch (p) {
        Z(
          "error",
          p instanceof Error ? p : new Error("Failed to toggle screen share")
        );
      }
    }), c = () => z(this, null, function* () {
      try {
        yield le(), Z("screen-share", !0, J.value);
      } catch (p) {
        Z(
          "error",
          p instanceof Error ? p : new Error("Failed to start screen share")
        );
      }
    }), C = () => {
      try {
        ze(), Z("screen-share", !1, null);
      } catch (p) {
        Z(
          "error",
          p instanceof Error ? p : new Error("Failed to stop screen share")
        );
      }
    }, F = (p, ie) => z(this, null, function* () {
      try {
        yield ve(p, ie), Z("device", p, ie);
      } catch (A) {
        Z(
          "error",
          A instanceof Error ? A : new Error(`Failed to change ${p} device`)
        );
      }
    }), G = () => z(this, null, function* () {
      try {
        yield Oe(), Z("camera-flip");
      } catch (p) {
        Z(
          "error",
          p instanceof Error ? p : new Error("Failed to flip camera")
        );
      }
    });
    $e(Se, (p) => {
      p ? setTimeout(() => {
        document.addEventListener("click", w);
      }, 100) : document.removeEventListener("click", w);
    }), h({
      // Device selections
      get selectedCamera() {
        return O.value;
      },
      get selectedMicrophone() {
        return P.value;
      },
      get selectedSpeaker() {
        return $.value;
      },
      // Stream states
      get isCameraEnabled() {
        return M.value;
      },
      get isMicrophoneEnabled() {
        return b.value;
      },
      get isScreenShareEnabled() {
        return D.value;
      },
      // Streams
      get videoStream() {
        return B.value;
      },
      get audioStream() {
        return ke.value;
      },
      get screenShareStream() {
        return J.value;
      },
      // Control methods (use wrapper methods that emit events)
      toggleCamera: Y,
      toggleMicrophone: Re,
      toggleScreenShare: at,
      // Explicitly turn on/off (use wrapper methods that emit events)
      startCamera: Q,
      stopCamera: Ne,
      startMicrophone: he,
      stopMicrophone: et,
      startScreenShare: c,
      stopScreenShare: C
    });
    const me = a(() => Ie.value ? e.value ? "down" : "up" : e.value ? "right" : "left");
    return (p, ie) => (r(), v("div", {
      ref_key: "controlBarRef",
      ref: Fe,
      class: Ce(["control-bar", {
        vertical: Ie.value,
        [`position-${T.embeddedPosition}`]: He.value,
        "screen-share-active": s(D),
        collapsed: e.value,
        "no-background": !ue.value
      }]),
      style: m(Le.value),
      "data-control-size": ae.value,
      "data-gap-size": oe.value,
      "data-dropdown-width": Ee.value,
      "data-edge-offset": we.value
    }, [
      X(wa, {
        name: "controls-animation",
        tag: "div",
        class: "controls-group"
      }, {
        default: Ae(() => [
          p.controls && p.controls.length > 0 ? (r(), v(Ve, { key: 0 }, [
            (r(!0), v(Ve, null, st(N.value, (A) => (r(), v(Ve, { key: A }, [
              A === "camera" ? (r(), be(tt, {
                key: 0,
                active: s(M),
                title: Ze(),
                "no-background": !ue.value,
                style: m(
                  s(M) ? Te.value : fe.value
                ),
                class: Ce([{
                  "permission-denied": s(ee).state === "denied"
                }, "control-item"]),
                onClick: Y
              }, {
                default: Ae(() => [
                  X(Vt, {
                    variant: s(M) ? "on" : "mute",
                    size: j.value
                  }, null, 8, ["variant", "size"]),
                  s(ee).state === "denied" ? (r(), v("div", bn, " ! ")) : E("", !0)
                ]),
                _: 1
              }, 8, ["active", "title", "no-background", "style", "class"])) : E("", !0),
              A === "microphone" ? (r(), be(tt, {
                key: 1,
                active: s(b),
                title: De(),
                "no-background": !ue.value,
                style: m(
                  s(b) ? Te.value : fe.value
                ),
                class: Ce([{
                  "permission-denied": s(n).state === "denied"
                }, "control-item"]),
                onClick: Re
              }, {
                default: Ae(() => [
                  X(Ot, {
                    variant: s(b) ? "on" : "mute",
                    size: j.value
                  }, null, 8, ["variant", "size"]),
                  s(n).state === "denied" ? (r(), v("div", kn, " ! ")) : E("", !0)
                ]),
                _: 1
              }, 8, ["active", "title", "no-background", "style", "class"])) : E("", !0),
              A === "screen-share" ? (r(), be(tt, {
                key: 2,
                active: s(D),
                disabled: !s(g),
                title: We(),
                "no-background": !ue.value,
                style: m(
                  s(D) ? Te.value : fe.value
                ),
                class: Ce([{
                  "permission-denied": s(V).state === "denied"
                }, "control-item"]),
                onClick: ie[0] || (ie[0] = (nt) => s(g) ? at() : void 0)
              }, {
                default: Ae(() => [
                  X(Ua, {
                    variant: s(D) ? "on" : "off",
                    size: j.value
                  }, null, 8, ["variant", "size"]),
                  s(V).state === "denied" ? (r(), v("div", wn, " ! ")) : E("", !0)
                ]),
                _: 1
              }, 8, ["active", "disabled", "title", "no-background", "style", "class"])) : E("", !0),
              A === "speaker" ? (r(), be(tt, {
                key: 3,
                active: !1,
                title: "Speaker settings",
                "no-background": !ue.value,
                style: m(fe.value),
                class: "control-item",
                onClick: I
              }, {
                default: Ae(() => [
                  X(Ht, {
                    variant: "on",
                    size: j.value
                  }, null, 8, ["size"])
                ]),
                _: 1
              }, 8, ["no-background", "style"])) : E("", !0),
              A === "settings" ? (r(), v("div", Cn, [
                X(tt, {
                  active: Se.value,
                  title: "Device settings",
                  "no-background": !ue.value,
                  style: m(
                    Se.value ? Te.value : fe.value
                  ),
                  onClick: I
                }, {
                  default: Ae(() => [
                    X(Wa, {
                      variant: Se.value ? "on" : "off",
                      size: j.value
                    }, null, 8, ["variant", "size"])
                  ]),
                  _: 1
                }, 8, ["active", "no-background", "style"])
              ])) : E("", !0),
              A === "camera-flip" ? (r(), be(tt, {
                key: 5,
                disabled: !s(M) || !s(K),
                title: s(K) ? s(M) ? "Flip camera" : "Enable camera first" : "Camera flip not available - only one camera detected",
                "no-background": !ue.value,
                style: m(fe.value),
                class: "control-item",
                onClick: G
              }, {
                default: Ae(() => [
                  X(Ya, { size: j.value }, null, 8, ["size"])
                ]),
                _: 1
              }, 8, ["disabled", "title", "no-background", "style"])) : E("", !0)
            ], 64))), 128)),
            p.controls.length > 3 ? (r(), be(tt, {
              key: "toggle-button",
              class: "control-item toggle-button",
              active: !1,
              title: e.value ? "Show more controls" : "Show fewer controls",
              "no-background": !ue.value,
              style: m(fe.value),
              onClick: S
            }, {
              default: Ae(() => [
                X(Xa, {
                  variant: me.value,
                  size: j.value
                }, null, 8, ["variant", "size"])
              ]),
              _: 1
            }, 8, ["title", "no-background", "style"])) : E("", !0)
          ], 64)) : E("", !0)
        ]),
        _: 1
      }),
      p.$slots["end-controls"] ? (r(), v("div", xn, [
        qe(p.$slots, "end-controls", {}, void 0, !0)
      ])) : E("", !0),
      Se.value ? (r(), v("div", {
        key: 1,
        ref_key: "settingsDropdown",
        ref: je,
        class: "settings-dropdown",
        style: m(Pe.value)
      }, [
        o("div", Tn, [
          p.controls && p.controls.includes("camera") ? (r(), v("div", {
            key: 0,
            class: "device-select",
            style: m(Ue.value)
          }, [
            o("div", _n, [
              X(Vt, {
                class: "device-icon",
                size: j.value * 0.75
              }, null, 8, ["size"]),
              o("select", {
                id: "camera-select",
                value: s(O),
                onChange: ie[1] || (ie[1] = (A) => F("camera", A.target.value))
              }, [
                (r(!0), v(Ve, null, st(s(y), (A) => (r(), v("option", {
                  key: A.deviceId,
                  value: A.deviceId
                }, de(A.label || `Camera ${s(y).indexOf(A) + 1}`), 9, zn))), 128))
              ], 40, En),
              X(xt, {
                class: "arrow-icon",
                size: j.value * 0.75
              }, null, 8, ["size"])
            ])
          ], 4)) : E("", !0),
          p.controls && p.controls.includes("microphone") ? (r(), v("div", {
            key: 1,
            class: "device-select",
            style: m(Ue.value)
          }, [
            o("div", Mn, [
              X(Ot, {
                class: "device-icon",
                size: j.value * 0.75
              }, null, 8, ["size"]),
              o("select", {
                id: "mic-select",
                value: s(P),
                onChange: ie[2] || (ie[2] = (A) => F("microphone", A.target.value))
              }, [
                (r(!0), v(Ve, null, st(s(x), (A) => (r(), v("option", {
                  key: A.deviceId,
                  value: A.deviceId
                }, de(A.label || `Microphone ${s(x).indexOf(A) + 1}`), 9, Pn))), 128))
              ], 40, In),
              X(xt, {
                class: "arrow-icon",
                size: j.value * 0.75
              }, null, 8, ["size"])
            ]),
            s(b) ? (r(), v("div", Bn, [
              X(Ia, {
                "icon-color": T.iconColor,
                "icon-size": j.value * 0.75
              }, null, 8, ["icon-color", "icon-size"])
            ])) : (r(), v("div", {
              key: 1,
              class: "mic-disabled-message",
              style: m(Ke.value)
            }, " Enable microphone to see audio level ", 4))
          ], 4)) : E("", !0),
          p.controls && p.controls.includes("speaker") ? (r(), v("div", {
            key: 2,
            class: "device-select",
            style: m(Ue.value)
          }, [
            o("div", An, [
              X(Ht, {
                class: "device-icon",
                size: j.value * 0.75
              }, null, 8, ["size"]),
              o("select", {
                id: "speaker-select",
                value: s($),
                onChange: ie[3] || (ie[3] = (A) => F("speaker", A.target.value))
              }, [
                (r(!0), v(Ve, null, st(s(R), (A) => (r(), v("option", {
                  key: A.deviceId,
                  value: A.deviceId
                }, de(A.label || `Speaker ${s(R).indexOf(A) + 1}`), 9, Rn))), 128))
              ], 40, Ln),
              X(xt, {
                class: "arrow-icon",
                size: j.value * 0.75
              }, null, 8, ["size"])
            ])
          ], 4)) : E("", !0)
        ])
      ], 4)) : E("", !0),
      _.value ? (r(), be(Kt, {
        key: 2,
        "camera-permission": s(ee),
        "microphone-permission": s(n),
        onClose: ie[4] || (ie[4] = (A) => _.value = !1)
      }, null, 8, ["camera-permission", "microphone-permission"])) : E("", !0)
    ], 14, Sn));
  }
}), jo = /* @__PURE__ */ Xe($n, [["__scopeId", "data-v-a8560bb2"]]), Fn = { class: "icon-circle-outer" }, Dn = { class: "icon-circle-inner" }, jn = {
  key: 2,
  class: "message-spacer"
}, Nn = { class: "message-content" }, Vn = ["onClick"], On = ["src", "alt"], Hn = ["src"], Un = ["title"], Wn = { class: "attachment-size" }, Yn = ["onClick"], Xn = {
  key: 0,
  class: "file-preview-thumbnail"
}, Gn = ["src", "alt"], Kn = ["disabled", "title"], Qn = ["placeholder", "maxlength", "disabled"], Jn = { class: "buttons-row" }, qn = { class: "icons-group" }, Zn = ["disabled"], eo = ["disabled"], to = ["disabled"], ao = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  class: "progress-ring"
}, no = ["stroke-dasharray"], oo = ["disabled"], so = { class: "input-wrapper" }, ro = ["placeholder", "maxlength", "disabled", "onKeydown"], lo = ["disabled"], io = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  class: "progress-ring"
}, co = ["stroke-dasharray"], uo = ["accept"], vo = /* @__PURE__ */ Ye({
  __name: "StreamChat",
  props: {
    containerStyle: {},
    messageListStyle: {},
    maxHeight: {},
    bubbleStyle: {},
    ownBubbleStyle: {},
    otherBubbleStyle: {},
    bubbleShape: { default: "square" },
    messageTextStyle: {},
    senderNameStyle: {},
    timestampStyle: {},
    fontFamily: {},
    inputContainerStyle: {},
    inputFieldStyle: {},
    sendButtonStyle: {},
    attachmentButtonStyle: {},
    emojiButtonStyle: {},
    emojiPickerConfig: {},
    emojiPickerStyle: {},
    avatarStyle: {},
    emptyStateStyle: {},
    emptyStateContentStyle: {},
    emptyStateIconStyle: {},
    emptyStateHeadingStyle: {},
    emptyStateMessageStyle: {},
    loadingIndicatorStyle: {},
    loadingSpinnerStyle: {},
    loadingTextStyle: {},
    skeletonStyle: {},
    skeletonAvatarStyle: {},
    skeletonContentStyle: {},
    skeletonNameStyle: {},
    skeletonTextStyle: {},
    scrollButtonStyle: {},
    newMessageNotificationStyle: {},
    errorNotificationStyle: {},
    errorNotificationContentStyle: {},
    errorNotificationTextStyle: {},
    errorDismissButtonStyle: {},
    filePreviewStyle: {},
    fileIconStyle: {},
    fileInfoStyle: {},
    fileNameStyle: {},
    fileSizeStyle: {},
    fileRemoveButtonStyle: {},
    attachmentContainerStyle: {},
    imageAttachmentStyle: {},
    videoAttachmentStyle: {},
    documentAttachmentStyle: {},
    downloadButtonStyle: {},
    attachmentInfoStyle: {},
    attachmentDetailsStyle: {},
    hostTagStyle: {},
    showAvatars: { type: Boolean, default: !0 },
    showTimestamps: { type: Boolean, default: !0 },
    showSenderNames: { type: Boolean, default: !0 },
    timestampFormat: { default: "HH:mm" },
    enableEmoji: { type: Boolean, default: !0 },
    enableFileAttachment: { type: Boolean, default: !0 },
    maxMessageLength: { default: 500 },
    maxFileSize: { default: 5 * 1024 * 1024 },
    allowedFileTypes: { default: "image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip" },
    inputPlaceholder: { default: "Type a message..." },
    currentUserName: { default: "You" },
    avatarBackgroundColor: { default: "rgba(0, 0, 0, 0.5)" },
    enableNotificationSound: { type: Boolean, default: !1 },
    autoScroll: { type: Boolean, default: !0 },
    scrollThreshold: { default: 100 }
  },
  emits: ["message-sent", "message-received", "file-selected"],
  setup(W, { expose: h, emit: f }) {
    const e = W, S = f, N = k(), d = k(), y = k(), x = k(), R = k(), M = k(""), b = k(!0), D = k(null), g = k(null), K = k(null), ee = k(!1), n = it("isInsidePlayerSlot", !1), { messages: V, sendMessage: O, clearMessages: P } = Pa(), $ = a(() => {
      var l;
      return ((l = ke.value) == null ? void 0 : l.name) || e.currentUserName;
    }), { connectionState: B } = dt(), { localParticipant: ke } = Et(), J = a(() => "file-transfer-room"), te = a(() => B.value === pe.Connected), {
      fileMessages: H,
      isUploading: q,
      uploadProgress: xe,
      sendFile: ge,
      clearFileMessages: ye
    } = Ba(J.value), { recordMessage: re } = Aa(), le = La(), ze = Fa(), {
      historicalMessages: ve,
      hasMore: Oe,
      isInitialLoading: _e,
      isLoadingMore: Fe,
      loadMoreHistory: Ge
    } = Ra({
      pageSize: 15,
      onError: (l) => {
      }
    }), ne = a(() => {
      const l = [], u = /* @__PURE__ */ new Map();
      V.value.forEach((L) => {
        const ce = L.text.match(/^\[FILE:([^\]]+)\](.*)$/);
        if (ce) {
          const [, Be, ot] = ce;
          u.set(Be, ot);
        }
      }), V.value.forEach((L) => {
        L.text.startsWith("[FILE:") || l.push(pt(t({}, L), {
          attachment: void 0
        }));
      }), H.value.forEach((L) => {
        const ce = L.isOwn ? $.value : L.senderName, Be = u.get(L.streamId) || "";
        l.push({
          id: L.id,
          text: Be,
          // Use associated text from data channel
          senderName: ce,
          senderIdentity: L.senderIdentity,
          senderIdentityType: L.senderIdentityType,
          senderAvatar: L.senderAvatar,
          senderRole: L.senderRole,
          timestamp: L.timestamp,
          isOwn: L.isOwn,
          attachment: {
            id: L.streamId,
            name: L.fileName,
            size: L.fileSize,
            type: L.mimeType,
            url: L.url
          }
        });
      });
      const i = ve.value.map((L) => {
        var ce;
        return pt(t({}, L), {
          isOwn: L.senderIdentity === ((ce = ke.value) == null ? void 0 : ce.identity)
        });
      });
      return $a(
        i,
        l
      );
    }), U = a(() => t(t({
      fontFamily: e.fontFamily
    }, n && !e.containerStyle ? {
      background: "transparent",
      backdropFilter: "none"
    } : {}), e.containerStyle)), ae = a(() => t(t({
      maxHeight: e.maxHeight
    }, n && !e.messageListStyle ? {
      background: "transparent"
    } : {}), e.messageListStyle)), oe = a(() => t(t({}, n && !e.messageTextStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.messageTextStyle)), se = a(() => t(t({}, n && !e.senderNameStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.senderNameStyle)), j = a(() => t(t({}, n && !e.timestampStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.timestampStyle)), Ee = a(() => t(t({}, n && !e.inputContainerStyle ? {
      background: "transparent",
      borderTop: "none"
    } : {}), e.inputContainerStyle)), we = a(() => t(t({
      fontFamily: e.fontFamily
    }, n && !e.inputFieldStyle ? {
      background: "transparent",
      borderColor: "rgba(255, 255, 255)",
      backdropFilter: "none",
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.inputFieldStyle)), Me = a(() => t(t({}, n && !e.sendButtonStyle ? {
      background: "rgba(0, 0, 0, 0.5)",
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.sendButtonStyle)), T = a(() => t(t({}, n && !e.attachmentButtonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.attachmentButtonStyle)), ue = a(() => t(t({}, n && !e.emojiButtonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.emojiButtonStyle)), Ie = a(() => t(t({}, n && !e.avatarStyle ? {
      filter: "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3))"
    } : {}), e.avatarStyle)), He = a(() => t(t({}, n && !e.emptyStateStyle ? {
      background: "transparent"
    } : {}), e.emptyStateStyle)), Le = a(() => t(t({}, n && !e.emptyStateContentStyle ? {
      filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))"
    } : {}), e.emptyStateContentStyle)), fe = a(() => t(t({}, n && !e.emptyStateIconStyle ? {
      filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.4))"
    } : {}), e.emptyStateIconStyle)), Te = a(() => t(t({}, n && !e.emptyStateHeadingStyle ? {
      color: "white",
      textShadow: "0 1px 2px rgba(0, 0, 0, 0.5)"
    } : {}), e.emptyStateHeadingStyle)), Pe = a(() => t(t({}, n && !e.emptyStateMessageStyle ? {
      color: "rgba(255, 255, 255, 0.8)",
      textShadow: "0 1px 2px rgba(0, 0, 0, 0.5)"
    } : {}), e.emptyStateMessageStyle)), Ue = a(() => t(t({}, n && !e.loadingIndicatorStyle ? {
      filter: "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3))"
    } : {}), e.loadingIndicatorStyle)), Ke = a(() => t(t({}, n && !e.loadingSpinnerStyle ? {
      borderColor: "rgba(255, 255, 255, 0.3)",
      borderTopColor: "white"
    } : {}), e.loadingSpinnerStyle)), Ze = a(() => t(t({}, n && !e.loadingTextStyle ? {
      color: "rgba(255, 255, 255, 0.8)",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)"
    } : {}), e.loadingTextStyle)), De = a(() => t(t({}, n && !e.skeletonStyle ? {
      background: "rgba(255, 255, 255, 0.05)",
      borderTopColor: "rgba(255, 255, 255, 0.1)"
    } : {}), e.skeletonStyle)), We = a(() => t(t({}, n && !e.skeletonAvatarStyle ? {
      background: "linear-gradient(90deg, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.1) 75%)"
    } : {}), e.skeletonAvatarStyle)), Z = a(() => t(t({}, n && !e.skeletonContentStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.skeletonContentStyle)), Se = a(() => t(t({}, n && !e.skeletonNameStyle ? {
      background: "linear-gradient(90deg, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.1) 75%)"
    } : {}), e.skeletonNameStyle)), je = a(() => t(t({}, n && !e.skeletonTextStyle ? {
      background: "linear-gradient(90deg, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.1) 75%)"
    } : {}), e.skeletonTextStyle)), _ = a(() => t(t({}, n && !e.scrollButtonStyle ? {
      background: "rgba(0, 0, 0, 0.7)",
      backdropFilter: "blur(10px)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)"
    } : {}), e.scrollButtonStyle)), I = a(() => t(t({}, n && !e.newMessageNotificationStyle ? {
      background: "rgba(0, 0, 0, 0.8)",
      backdropFilter: "blur(10px)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)"
    } : {}), e.newMessageNotificationStyle)), w = a(() => t(t({}, n && !e.errorNotificationStyle ? {
      filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))"
    } : {}), e.errorNotificationStyle)), Y = a(() => t(t({}, n && !e.errorNotificationContentStyle ? {
      background: "rgba(255, 215, 0, 0.95)",
      backdropFilter: "blur(8px)"
    } : {}), e.errorNotificationContentStyle)), Q = a(() => t(t({}, n && !e.errorNotificationTextStyle ? {
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.2)"
    } : {}), e.errorNotificationTextStyle)), Ne = a(() => t(t({}, n && !e.errorDismissButtonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.errorDismissButtonStyle)), Re = a(() => t(t({}, n && !e.filePreviewStyle ? {
      background: "rgba(240, 242, 245, 0.95)",
      backdropFilter: "blur(8px)",
      border: "1px solid rgba(255, 255, 255, 0.2)"
    } : {}), e.filePreviewStyle)), he = a(() => t(t({}, n && !e.fileIconStyle ? {
      background: "rgba(233, 236, 239, 0.9)",
      color: "rgba(108, 117, 125, 0.9)"
    } : {}), e.fileIconStyle)), et = a(() => t(t({}, n && !e.fileInfoStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.fileInfoStyle)), at = a(() => t(t({}, n && !e.fileNameStyle ? {
      color: "white",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)"
    } : {}), e.fileNameStyle)), c = a(() => t(t({}, n && !e.fileSizeStyle ? {
      color: "rgba(255, 255, 255, 0.8)",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)"
    } : {}), e.fileSizeStyle)), C = a(() => t(t({}, n && !e.fileRemoveButtonStyle ? {
      background: "rgba(255, 255, 255, 0.1)",
      color: "rgba(255, 255, 255, 0.8)",
      backdropFilter: "blur(4px)"
    } : {}), e.fileRemoveButtonStyle)), F = a(() => t(t({}, n && !e.attachmentContainerStyle ? {
      filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2))"
    } : {}), e.attachmentContainerStyle)), G = a(() => t(t({}, n && !e.imageAttachmentStyle ? {
      border: "2px solid rgba(255, 255, 255, 0.3)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)"
    } : {}), e.imageAttachmentStyle)), me = a(() => t(t({}, n && !e.videoAttachmentStyle ? {
      border: "2px solid rgba(255, 255, 255, 0.3)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)"
    } : {}), e.videoAttachmentStyle)), p = a(() => t(t({}, n && !e.documentAttachmentStyle ? {
      background: "rgba(255, 255, 255, 0.1)",
      borderColor: "rgba(255, 255, 255, 0.2)",
      backdropFilter: "blur(8px)"
    } : {}), e.documentAttachmentStyle)), ie = a(() => t(t({}, n && !e.downloadButtonStyle ? {
      background: "rgba(255, 255, 255, 0.1)",
      borderColor: "rgba(255, 255, 255, 0.3)",
      color: "white"
    } : {}), e.downloadButtonStyle)), A = a(() => t(t({}, n && !e.attachmentInfoStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.attachmentInfoStyle)), nt = a(() => t(t({}, n && !e.attachmentDetailsStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.attachmentDetailsStyle)), aa = a(() => t(t({}, n && !e.hostTagStyle ? {
      background: "rgba(87, 115, 255, 0.9)",
      backdropFilter: "blur(4px)",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)"
    } : {}), e.hostTagStyle)), bt = a(() => te.value && (M.value.trim() || D.value) && !q.value), na = (l) => {
      let u = e.bubbleStyle || {};
      n && !e.bubbleStyle && (u = t({
        background: "transparent"
      }, u));
      const i = l.isOwn ? e.ownBubbleStyle || (n ? { background: "transparent" } : {}) : e.otherBubbleStyle || (n ? { background: "transparent" } : {});
      return pt(t(t({}, u), i), {
        marginLeft: "0",
        marginRight: "auto"
      });
    }, oa = (l) => {
      const u = new Date(l);
      return e.timestampFormat === "HH:mm" ? u.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : u.toLocaleString();
    }, sa = () => z(this, null, function* () {
      if (!d.value) return;
      const { scrollTop: l, scrollHeight: u, clientHeight: i } = d.value;
      if (b.value = u - l - i < e.scrollThreshold, ee.value = !b.value && ne.value.length > 0, l < 100 && Oe.value && !Fe.value && !_e.value) {
        const ce = u;
        yield Ge(), kt(() => {
          if (d.value) {
            const ot = d.value.scrollHeight - ce;
            d.value.scrollTop = l + ot;
          }
        });
      }
    }), vt = (l = !0) => {
      d.value && (d.value.scrollTop = d.value.scrollHeight);
    }, ra = (l) => {
      l.shiftKey || (l.preventDefault(), mt());
    }, la = () => {
      if (!y.value || n) return;
      const l = y.value;
      l.tagName === "TEXTAREA" && (l.style.height = "auto", l.style.height = Math.min(l.scrollHeight, 120) + "px");
    }, mt = () => z(this, null, function* () {
      if (!bt.value) return;
      const l = M.value.trim();
      if (!(!l && !D.value))
        try {
          let u = null;
          if (D.value) {
            const i = yield ge(
              D.value,
              void 0,
              // Don't pass text since attributes aren't supported
              J.value
            );
            l && (yield O(`[FILE:${i.streamId}]${l}`)), u = {
              id: i.id,
              text: l || "",
              // Text is now sent separately via data channel
              senderName: $.value,
              senderIdentity: i.senderIdentity,
              senderIdentityType: i.senderIdentityType,
              senderAvatar: i.senderAvatar,
              senderRole: i.senderRole,
              timestamp: i.timestamp,
              attachment: {
                id: i.streamId,
                name: i.fileName,
                size: i.fileSize,
                type: i.mimeType,
                url: i.url
              }
            };
          } else if (l) {
            const i = yield O(l);
            i && (u = {
              id: i.id,
              text: l || "",
              // Text is now sent separately via data channel
              senderName: $.value,
              senderIdentity: i.senderIdentity,
              senderIdentityType: i.senderIdentityType,
              senderAvatar: i.senderAvatar,
              senderRole: i.senderRole,
              timestamp: i.timestamp
            });
          }
          u && re(u).catch((i) => null).then((i) => {
            i && S("message-sent", i);
          }), M.value = "", g.value && (URL.revokeObjectURL(g.value), g.value = null), D.value = null;
        } catch (u) {
        }
    }), ia = () => {
      var l;
      (l = x.value) == null || l.click();
    }, It = () => z(this, null, function* () {
      if (!(!R.value || !y.value))
        try {
          const u = t(t({}, {
            theme: n ? "dark" : "auto",
            perLine: 8,
            emojiSize: 24,
            emojiButtonSize: 32,
            searchPosition: "none"
          }), e.emojiPickerConfig), i = {};
          e.emojiPickerStyle && Object.entries(e.emojiPickerStyle).forEach(([L, ce]) => {
            if (ce != null) {
              const Be = L.replace(/([A-Z])/g, "-$1").toLowerCase();
              i[Be] = String(ce);
            }
          }), yield le.togglePicker(
            R.value,
            (L) => {
              ca(L.native);
            },
            u,
            i
          );
        } catch (l) {
        }
    }), ca = (l) => {
      const u = y.value;
      if (!u) return;
      const i = u.selectionStart || 0, L = u.selectionEnd || 0, ce = M.value, Be = ce.slice(0, i) + l + ce.slice(L);
      M.value = Be, kt(() => {
        const ot = i + l.length;
        u.setSelectionRange(ot, ot), u.focus();
      });
    }, ua = (l) => {
      var L;
      const u = l.target, i = (L = u.files) == null ? void 0 : L[0];
      if (i) {
        if (i.size > e.maxFileSize) {
          const ce = Math.round(e.maxFileSize / 1048576);
          K.value = `File too large. Please select a file smaller than ${ce} MB.`, setTimeout(() => {
            K.value = null;
          }, 5e3), u.value = "";
          return;
        }
        D.value = i, ht(i.type) && (g.value = URL.createObjectURL(i)), S("file-selected", i), u.value = "";
      }
    }, da = () => {
      q.value || (g.value && (URL.revokeObjectURL(g.value), g.value = null), D.value = null, x.value && (x.value.value = ""));
    }, Pt = (l) => {
      if (l === 0) return "0 Bytes";
      const u = 1024, i = ["Bytes", "KB", "MB", "GB"], L = Math.floor(Math.log(l) / Math.log(u));
      return Math.round(l / Math.pow(u, L) * 100) / 100 + " " + i[L];
    }, va = (l) => {
      const u = l.split(".");
      return u.length > 1 ? u[u.length - 1] : "";
    }, ma = (l, u = 20) => {
      if (l.length <= u) return l;
      const i = l.lastIndexOf(".");
      if (i === -1)
        return l.substring(0, u) + "...";
      const L = l.substring(i), ce = l.substring(0, i), Be = u - L.length - 3;
      return Be <= 0 ? l.substring(0, u) + "..." : ce.length <= Be ? l : ce.substring(0, Be) + "..." + L;
    }, ht = (l) => l.startsWith("image/"), pa = (l) => l.startsWith("video/"), fa = (l) => {
      if (!l.url)
        return;
      const u = document.createElement("a");
      u.href = l.url, u.download = l.name, document.body.appendChild(u), u.click(), document.body.removeChild(u);
    }, ha = (l) => {
      l.url && ht(l.type) && window.open(l.url, "_blank");
    };
    return $e(ne, () => {
      e.autoScroll && b.value && kt(() => vt());
    }), $e(
      () => V.value.length,
      (l, u) => z(this, null, function* () {
        if (l > u) {
          const i = V.value[V.value.length - 1];
          if (i && !i.isOwn && (S("message-received", i), e.enableNotificationSound))
            try {
              yield ze.playSound(
                Da.MESSAGE_RECEIVED
              );
            } catch (L) {
            }
        }
      })
    ), ut(() => {
      vt(!1);
      const l = document.createElement("link");
      l.rel = "prefetch", l.href = "https://cdn.jsdelivr.net/npm/emoji-mart@5.6.0/dist/browser.js", document.head.appendChild(l);
      const u = document.createElement("link");
      u.rel = "prefetch", u.href = "https://cdn.jsdelivr.net/npm/@emoji-mart/data", document.head.appendChild(u);
    }), h({
      // Methods
      sendMessage: mt,
      clearMessages: () => {
        P(), ye();
      },
      scrollToBottom: vt,
      // State
      messages: ne,
      isConnected: a(() => te.value),
      messageInput: M,
      // Refs
      inputRef: y
    }), (l, u) => (r(), v("div", {
      ref_key: "chatContainerRef",
      ref: N,
      class: Ce(["stream-chat", { "inside-player": s(n) }]),
      style: m(U.value)
    }, [
      o("div", {
        ref_key: "messageListRef",
        ref: d,
        class: "message-list",
        style: m(ae.value),
        onScroll: sa
      }, [
        s(Fe) ? (r(), v("div", {
          key: 0,
          class: "loading-more-indicator",
          style: m(Ue.value)
        }, [
          o("div", {
            class: "loading-spinner",
            style: m(Ke.value)
          }, null, 4),
          o("span", {
            class: "loading-text",
            style: m(Ze.value)
          }, "Loading older messages...", 4)
        ], 4)) : E("", !0),
        !s(_e) && ne.value.length === 0 && !s(n) ? (r(), v("div", {
          key: 1,
          class: "empty-state",
          style: m(He.value)
        }, [
          o("div", {
            class: "empty-state-content",
            style: m(Le.value)
          }, [
            o("div", {
              class: "empty-state-icon",
              style: m(fe.value)
            }, [
              o("div", Fn, [
                o("div", Dn, [
                  X(Ga, { size: 20 })
                ])
              ])
            ], 4),
            o("h3", {
              class: "empty-state-heading",
              style: m(Te.value)
            }, de(te.value ? "No conversations yet" : "Welcome to Chat"), 5),
            o("p", {
              class: "empty-state-message",
              style: m(Pe.value)
            }, de(te.value ? "Start a new chat to get the conversation going!" : "Start the session to get conversation going!"), 5)
          ], 4)
        ], 4)) : s(_e) ? E("", !0) : (r(), v("div", jn)),
        (r(!0), v(Ve, null, st(ne.value, (i) => (r(), v("div", {
          key: i.id,
          class: Ce(["message-wrapper", { "own-message": i.isOwn }])
        }, [
          l.showAvatars ? (r(), v("div", {
            key: 0,
            class: "message-avatar",
            style: m(Ie.value)
          }, [
            X(Mt, {
              name: i.senderName,
              image: i.senderAvatar,
              size: "small",
              "background-color": l.avatarBackgroundColor
            }, null, 8, ["name", "image", "background-color"])
          ], 4)) : E("", !0),
          o("div", Nn, [
            l.showSenderNames ? (r(), v("div", {
              key: 0,
              class: "message-sender",
              style: m(se.value)
            }, [
              Ca(de(i.senderName) + " ", 1),
              i.senderRole === "host" ? (r(), v("span", {
                key: 0,
                class: "host-tag",
                style: m(aa.value)
              }, "Host", 4)) : E("", !0),
              l.showTimestamps ? (r(), v("span", {
                key: 1,
                class: "message-timestamp inline",
                style: m(j.value)
              }, de(oa(i.timestamp)), 5)) : E("", !0)
            ], 4)) : E("", !0),
            o("div", {
              class: Ce(["message-bubble", `bubble-${l.bubbleShape}`]),
              style: m(na(i))
            }, [
              i.text ? (r(), v("p", {
                key: 0,
                class: "message-text preserve-whitespace",
                style: m(oe.value)
              }, de(i.text), 5)) : E("", !0),
              i.attachment ? (r(), v("div", {
                key: 1,
                class: "message-attachment-container",
                style: m(F.value)
              }, [
                ht(i.attachment.type) ? (r(), v("div", {
                  key: 0,
                  class: "message-attachment image-attachment",
                  style: m(G.value),
                  onClick: (L) => ha(i.attachment)
                }, [
                  o("img", {
                    src: i.attachment.url || "#",
                    alt: i.attachment.name,
                    class: "attachment-preview-image"
                  }, null, 8, On)
                ], 12, Vn)) : pa(i.attachment.type) ? (r(), v("div", {
                  key: 1,
                  class: "message-attachment video-attachment",
                  style: m(me.value)
                }, [
                  o("video", {
                    src: i.attachment.url || "#",
                    class: "attachment-preview-video",
                    controls: "",
                    preload: "metadata"
                  }, " Your browser does not support the video tag. ", 8, Hn)
                ], 4)) : (r(), v("div", {
                  key: 2,
                  class: "message-attachment document-attachment",
                  style: m(p.value)
                }, [
                  o("div", {
                    class: "attachment-info",
                    style: m(A.value)
                  }, [
                    X(Tt, { size: 20 }),
                    o("div", {
                      class: "attachment-details",
                      style: m(nt.value)
                    }, [
                      o("span", {
                        class: "attachment-name",
                        title: i.attachment.name
                      }, de(ma(i.attachment.name)), 9, Un),
                      o("span", Wn, de(Pt(i.attachment.size)), 1)
                    ], 4)
                  ], 4),
                  o("button", {
                    type: "button",
                    class: "download-button",
                    style: m(ie.value),
                    title: "Download",
                    onClick: (L) => fa(i.attachment)
                  }, u[6] || (u[6] = [
                    o("svg", {
                      width: "20",
                      height: "20",
                      viewBox: "0 0 20 20",
                      fill: "currentColor"
                    }, [
                      o("path", { d: "M10.75 2.75a.75.75 0 00-1.5 0v8.614L6.295 8.235a.75.75 0 10-1.09 1.03l4.25 4.5a.75.75 0 001.09 0l4.25-4.5a.75.75 0 00-1.09-1.03l-2.955 3.129V2.75z" }),
                      o("path", { d: "M3.5 12.75a.75.75 0 00-1.5 0v2.5A2.75 2.75 0 004.75 18h10.5A2.75 2.75 0 0018 15.25v-2.5a.75.75 0 00-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5z" })
                    ], -1)
                  ]), 12, Yn)
                ], 4))
              ], 4)) : E("", !0)
            ], 6)
          ])
        ], 2))), 128))
      ], 36),
      s(_e) ? (r(), v("div", {
        key: 0,
        class: "initial-loading-bottom",
        style: m(De.value)
      }, [
        (r(!0), v(Ve, null, st(s(n) ? 2 : 3, (i) => (r(), v("div", {
          key: i,
          class: "message-skeleton"
        }, [
          o("div", {
            class: "skeleton-avatar",
            style: m(We.value)
          }, null, 4),
          o("div", {
            class: "skeleton-content",
            style: m(Z.value)
          }, [
            o("div", {
              class: "skeleton-name",
              style: m(Se.value)
            }, null, 4),
            o("div", {
              class: "skeleton-text",
              style: m(je.value)
            }, null, 4),
            s(n) ? E("", !0) : (r(), v("div", {
              key: 0,
              class: "skeleton-text short",
              style: m(je.value)
            }, null, 4))
          ], 4)
        ]))), 128))
      ], 4)) : E("", !0),
      X(Lt, { name: "new-message-notification" }, {
        default: Ae(() => [
          ee.value && !b.value ? (r(), v("div", {
            key: 0,
            class: "new-message-notification",
            style: m(I.value),
            onClick: u[0] || (u[0] = (i) => vt(!0))
          }, u[7] || (u[7] = [
            o("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 20 20",
              fill: "currentColor"
            }, [
              o("path", { d: "M10 3a.75.75 0 01.75.75v10.638l3.96-4.158a.75.75 0 111.08 1.04l-5.25 5.5a.75.75 0 01-1.08 0l-5.25-5.5a.75.75 0 111.08-1.04l3.96 4.158V3.75A.75.75 0 0110 3z" })
            ], -1),
            o("span", { class: "new-message-text" }, "See latest", -1)
          ]), 4)) : E("", !0)
        ]),
        _: 1
      }),
      X(Lt, { name: "scroll-button" }, {
        default: Ae(() => [
          ee.value && b.value ? (r(), v("button", {
            key: 0,
            type: "button",
            class: Ce(["scroll-to-bottom-button", { "inside-player": s(n) }]),
            style: m(_.value),
            onClick: u[1] || (u[1] = (i) => vt(!0))
          }, u[8] || (u[8] = [
            o("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "currentColor"
            }, [
              o("path", { d: "M10 3a.75.75 0 01.75.75v10.638l3.96-4.158a.75.75 0 111.08 1.04l-5.25 5.5a.75.75 0 01-1.08 0l-5.25-5.5a.75.75 0 111.08-1.04l3.96 4.158V3.75A.75.75 0 0110 3z" })
            ], -1)
          ]), 6)) : E("", !0)
        ]),
        _: 1
      }),
      K.value ? (r(), v("div", {
        key: 1,
        class: "file-size-error-notification",
        style: m(w.value)
      }, [
        o("div", {
          class: "error-content",
          style: m(Y.value)
        }, [
          o("span", {
            class: "error-text",
            style: m(Q.value)
          }, de(K.value), 5),
          o("button", {
            type: "button",
            class: "error-dismiss-button",
            style: m(Ne.value),
            onClick: u[2] || (u[2] = (i) => K.value = null)
          }, " × ", 4)
        ], 4)
      ], 4)) : E("", !0),
      o("form", {
        class: "input-container",
        style: m(Ee.value),
        onSubmit: u[5] || (u[5] = Je(() => {
        }, ["prevent"]))
      }, [
        s(n) ? (r(), v(Ve, { key: 1 }, [
          l.enableEmoji ? (r(), v("button", {
            key: 0,
            ref_key: "emojiButtonRef",
            ref: R,
            type: "button",
            class: "emoji-button",
            style: m(ue.value),
            disabled: !te.value || s(le).isLoading.value,
            onClick: It
          }, [
            X(Ut, { size: 20 })
          ], 12, oo)) : E("", !0),
          o("div", so, [
            ct(o("input", {
              id: "message-input",
              ref_key: "inputRef",
              ref: y,
              "onUpdate:modelValue": u[4] || (u[4] = (i) => M.value = i),
              type: "text",
              class: "message-input",
              style: m(we.value),
              placeholder: l.inputPlaceholder,
              maxlength: l.maxMessageLength,
              disabled: !te.value,
              onKeydown: Rt(Je(mt, ["prevent"]), ["enter"])
            }, null, 44, ro), [
              [$t, M.value]
            ])
          ]),
          o("button", {
            type: "button",
            class: "send-button",
            style: m(Me.value),
            disabled: !bt.value,
            onClick: Je(mt, ["prevent"])
          }, [
            s(q) ? (r(), v("svg", io, [
              u[11] || (u[11] = o("circle", {
                cx: "10",
                cy: "10",
                r: "8",
                stroke: "currentColor",
                "stroke-width": "2",
                fill: "none",
                opacity: "0.2"
              }, null, -1)),
              o("circle", {
                cx: "10",
                cy: "10",
                r: "8",
                stroke: "currentColor",
                "stroke-width": "2",
                fill: "none",
                "stroke-linecap": "round",
                "stroke-dasharray": `${s(xe) * 50.3} 50.3`,
                transform: "rotate(-90 10 10)",
                class: "progress-ring-circle"
              }, null, 8, co)
            ])) : (r(), be(Wt, {
              key: 1,
              size: 20
            }))
          ], 12, lo)
        ], 64)) : (r(), v(Ve, { key: 0 }, [
          D.value ? (r(), v("div", {
            key: 0,
            class: "file-preview",
            style: m(Re.value)
          }, [
            g.value && ht(D.value.type) ? (r(), v("div", Xn, [
              o("img", {
                src: g.value,
                alt: D.value.name
              }, null, 8, Gn)
            ])) : (r(), v("div", {
              key: 1,
              class: "file-icon",
              style: m(he.value)
            }, [
              X(Tt, { size: 24 })
            ], 4)),
            o("div", {
              class: "file-info",
              style: m(et.value)
            }, [
              o("div", {
                class: "file-name",
                style: m(at.value)
              }, de(D.value.name), 5),
              o("div", {
                class: "file-size",
                style: m(c.value)
              }, de(Pt(D.value.size)) + ", " + de(va(D.value.name)), 5)
            ], 4),
            o("button", {
              type: "button",
              class: "file-remove-button",
              style: m(C.value),
              disabled: s(q),
              title: s(q) ? "Upload in progress" : "Remove file",
              onClick: da
            }, u[9] || (u[9] = [
              o("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                o("path", { d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" })
              ], -1)
            ]), 12, Kn)
          ], 4)) : E("", !0),
          ct(o("textarea", {
            id: "message-input",
            ref_key: "inputRef",
            ref: y,
            "onUpdate:modelValue": u[3] || (u[3] = (i) => M.value = i),
            class: "message-input standalone",
            style: m(we.value),
            placeholder: l.inputPlaceholder,
            maxlength: l.maxMessageLength,
            disabled: !te.value,
            rows: "2",
            onKeydown: Rt(ra, ["enter"]),
            onInput: la
          }, null, 44, Qn), [
            [$t, M.value]
          ]),
          o("div", Jn, [
            o("div", qn, [
              l.enableEmoji ? (r(), v("button", {
                key: 0,
                ref_key: "emojiButtonRef",
                ref: R,
                type: "button",
                class: "emoji-button",
                style: m(ue.value),
                disabled: !te.value || s(le).isLoading.value,
                onClick: It
              }, [
                X(Ut, { size: 20 })
              ], 12, Zn)) : E("", !0),
              l.enableFileAttachment ? (r(), v("button", {
                key: 1,
                type: "button",
                class: "attachment-button",
                style: m(T.value),
                disabled: !te.value,
                onClick: ia
              }, [
                X(Tt, { size: 20 })
              ], 12, eo)) : E("", !0)
            ]),
            o("button", {
              type: "button",
              class: "send-button",
              style: m(Me.value),
              disabled: !bt.value,
              onClick: Je(mt, ["prevent"])
            }, [
              s(q) ? (r(), v("svg", ao, [
                u[10] || (u[10] = o("circle", {
                  cx: "10",
                  cy: "10",
                  r: "8",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  fill: "none",
                  opacity: "0.2"
                }, null, -1)),
                o("circle", {
                  cx: "10",
                  cy: "10",
                  r: "8",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  fill: "none",
                  "stroke-linecap": "round",
                  "stroke-dasharray": `${s(xe) * 50.3} 50.3`,
                  transform: "rotate(-90 10 10)",
                  class: "progress-ring-circle"
                }, null, 8, no)
              ])) : (r(), be(Wt, {
                key: 1,
                size: 20
              }))
            ], 12, to)
          ])
        ], 64))
      ], 36),
      o("input", {
        ref_key: "fileInputRef",
        ref: x,
        type: "file",
        accept: l.allowedFileTypes,
        style: { display: "none" },
        onChange: ua
      }, null, 40, uo)
    ], 6));
  }
}), No = /* @__PURE__ */ Xe(vo, [["__scopeId", "data-v-fb9e4dc1"]]);
function mo(W) {
  const h = k(!1), f = k(!1), e = k(!1), S = wt(), N = wt(), d = wt(), y = k(!1), x = k(0);
  let R = null;
  return rt((M) => {
    const b = W.value;
    if (!b) {
      h.value = !1, f.value = !1, e.value = !1, S.value = void 0, N.value = void 0, d.value = void 0, y.value = !1, x.value = 0, R && (clearInterval(R), R = null);
      return;
    }
    const D = () => {
      const $ = b.getTrackPublication(ft.Source.ScreenShare);
      d.value = void 0, d.value = $, $ && $.track && !$.isMuted ? e.value = !0 : e.value = !1;
    }, g = () => {
      y.value = b.isSpeaking, x.value = b.audioLevel;
    }, ee = Va(b).subscribe({
      next: ($) => {
        h.value = $.isCameraEnabled, f.value = $.isMicrophoneEnabled, S.value = $.cameraTrack, N.value = $.microphoneTrack, D();
      },
      error: ($) => {
      }
    }), n = ($) => {
      $.source === ft.Source.ScreenShare && D();
    }, V = ($) => {
      $.source === ft.Source.ScreenShare && D();
    }, O = ($, B) => {
      B.source === ft.Source.ScreenShare && D();
    }, P = ($, B) => {
      B.source === ft.Source.ScreenShare && D();
    };
    b.on(Qe.TrackPublished, n), b.on(Qe.TrackUnpublished, V), b.on(Qe.TrackSubscribed, O), b.on(Qe.TrackUnsubscribed, P), b.on(jt.IsSpeakingChanged, g), D(), g(), R = window.setInterval(() => {
      b.audioLevel !== x.value && (x.value = b.audioLevel);
    }, 50), M(() => {
      ee.unsubscribe(), b.off(Qe.TrackPublished, n), b.off(Qe.TrackUnpublished, V), b.off(Qe.TrackSubscribed, O), b.off(Qe.TrackUnsubscribed, P), b.off(jt.IsSpeakingChanged, g), R && (clearInterval(R), R = null);
    });
  }), {
    isCameraEnabled: h,
    isMicrophoneEnabled: f,
    isScreenShareEnabled: e,
    cameraTrack: S,
    microphoneTrack: N,
    screenShareTrack: d,
    isSpeaking: y,
    audioLevel: x
  };
}
const po = { class: "video-container" }, fo = {
  key: 0,
  class: "loading-overlay"
}, ho = {
  key: 0,
  class: "spinner"
}, yo = { class: "loading-text" }, go = {
  key: 1,
  class: "host-avatar-placeholder"
}, So = {
  key: 2,
  class: "stream-info-overlay"
}, bo = { class: "status-bar" }, ko = /* @__PURE__ */ Ye({
  __name: "StreamAttendeePlayer",
  props: {
    licenseId: {},
    attendeeId: {},
    attendeeName: {},
    attendeeAvatar: {},
    videoFit: { default: "cover" },
    backgroundColor: { default: "#000000" },
    autoJoin: { type: Boolean, default: !0 },
    hideLoadingSpinner: { type: Boolean, default: !1 }
  },
  emits: ["stream-joined", "stream-left", "stream-ended", "recording-available", "session-started-at"],
  setup(W, { expose: h, emit: f }) {
    gt((c) => ({
      "299d9c90": e.backgroundColor,
      "11b25813": e.videoFit
    })), lt("isInsidePlayerSlot", !0);
    const e = W, S = f, N = k(null), d = k(null), y = k(null), x = k(null), R = k(null), { containerWidth: M } = St(N, {
      debounceTime: 100
    }), b = a(() => M.value < 768 ? 48 : 36), D = a(() => M.value < 768 ? 6 : 8), g = a(() => M.value < 768 ? 12 : 14), K = a(() => M.value < 768 ? "4px 8px" : "6px 10px"), { connect: ee, connectionState: n } = dt(), {
      host: V,
      hostMetadata: O,
      isConnected: P,
      joinStream: $,
      leaveStream: B
    } = qt(), ke = a(() => V.value), {
      isCameraEnabled: J,
      isMicrophoneEnabled: te,
      isScreenShareEnabled: H,
      cameraTrack: q,
      microphoneTrack: xe,
      screenShareTrack: ge,
      isSpeaking: ye,
      audioLevel: re
    } = mo(ke), le = it("streamControls");
    if (!le)
      throw new Error("StreamAttendeePlayer must be used within StreamProvider");
    const {
      setVideoElement: ze,
      isPlaying: ve,
      togglePlay: Oe,
      isMuted: _e,
      toggleMute: Fe,
      setVolume: Ge,
      volume: ne
    } = le, U = k(""), ae = k(!0), oe = k(null), se = /* @__PURE__ */ new Map();
    let j = null;
    const Ee = k(null), we = (c) => {
      const C = se.get(c);
      C && (C.forEach((F) => {
        "detach" in F && typeof F.detach == "function" && F.detach(c);
      }), se.delete(c));
    }, Me = (c, C) => z(this, null, function* () {
      if (!c || !C) return !1;
      if ("attach" in c && typeof c.attach == "function") {
        const F = se.get(C), G = F != null && F.size ? Array.from(F).some((p) => "kind" in p && p.kind === "video") : !1, me = "kind" in c && c.kind === "audio";
        return G && me || we(C), c.attach(C), se.has(C) || se.set(C, /* @__PURE__ */ new Set()), se.get(C).add(c), C instanceof HTMLVideoElement && T(C), !0;
      }
      return !1;
    }), T = (c) => {
      c && (c.volume = _e.value ? 0 : ne.value, c.muted = _e.value, ve.value && c.paused ? c.play().catch((C) => {
      }) : !ve.value && !c.paused && c.pause());
    }, ue = a(() => !!(U.value || n.value === pe.Connecting || n.value === pe.Reconnecting || n.value === pe.SignalReconnecting)), Ie = /* @__PURE__ */ new Map(), He = (c) => z(this, null, function* () {
      if (!c) return !1;
      try {
        Ie.has(c) && Ie.delete(c);
        const C = c.play();
        return Ie.set(c, C), yield C, Ie.delete(c), !0;
      } catch (C) {
        return Ie.delete(c), C instanceof Error && C.name === "AbortError", !1;
      }
    });
    let Le = null;
    const fe = () => {
      Le && clearTimeout(Le), Le = setTimeout(() => {
        Ke();
      }, 100);
    }, Te = () => z(this, null, function* () {
      var c, C;
      if (d.value)
        try {
          if (d.value.srcObject && (d.value.srcObject = null), J.value && !H.value) {
            const F = (c = q.value) == null ? void 0 : c.track;
            if (F) {
              const G = yield Me(
                F,
                d.value
              );
            }
          } else
            we(d.value);
          if (!H.value && te.value) {
            const F = (C = xe.value) == null ? void 0 : C.track;
            if (F && !(yield Me(
              F,
              d.value
            ))) {
              if ("mediaStreamTrack" in F) {
                const me = new MediaStream();
                me.addTrack(F.mediaStreamTrack), (!se.has(d.value) || se.get(d.value).size === 0) && (d.value.srcObject = me, yield He(d.value), T(d.value));
              }
            }
          }
        } catch (F) {
        }
    }), Pe = () => z(this, null, function* () {
      var c, C;
      if (y.value) {
        if (!H.value || !((c = ge.value) != null && c.track)) {
          we(y.value), y.value.srcObject && (y.value.srcObject = null);
          return;
        }
        try {
          y.value.srcObject && (y.value.srcObject = null);
          const F = ge.value.track;
          if (F) {
            const G = yield Me(
              F,
              y.value
            );
          }
          if (te.value) {
            const G = (C = xe.value) == null ? void 0 : C.track;
            if (G && !(yield Me(
              G,
              y.value
            ))) {
              if ("mediaStreamTrack" in G) {
                const p = new MediaStream();
                p.addTrack(G.mediaStreamTrack), (!se.has(y.value) || se.get(y.value).size === 0) && (y.value.srcObject = p, yield He(y.value), T(y.value));
              }
            }
          }
        } catch (F) {
        }
      }
    }), Ue = () => z(this, null, function* () {
      var C;
      if (!x.value) return;
      if (!J.value || !H.value) {
        we(x.value), x.value.srcObject && (x.value.srcObject = null);
        return;
      }
      const c = (C = q.value) == null ? void 0 : C.track;
      if (c)
        try {
          if (x.value.srcObject && (x.value.srcObject = null), !(yield Me(
            c,
            x.value
          ))) {
            if ("mediaStreamTrack" in c) {
              const G = new MediaStream();
              G.addTrack(c.mediaStreamTrack), x.value.srcObject = G, yield He(x.value);
            }
          }
        } catch (F) {
        }
    }), Ke = () => z(this, null, function* () {
      yield Promise.all([
        Te(),
        Pe(),
        Ue()
      ]);
    }), Ze = () => {
      fe();
    };
    $e(
      [
        J,
        te,
        H,
        q,
        xe,
        ge
      ],
      () => {
        Ze();
      },
      { deep: !0 }
    );
    const De = () => {
      Y.value = !0, Oe();
    };
    $e(
      [H, d, y],
      ([c]) => {
        const C = c ? y.value : d.value;
        if (C && C !== le.currentVideoElement.value && (ze(C), !he.has(C))) {
          const F = Re(C);
          F && he.set(C, F);
        }
      },
      { immediate: !0 }
    ), $e(
      x,
      (c) => {
        if (c && !he.has(c)) {
          const C = Re(c);
          C && he.set(c, C);
        }
      },
      { immediate: !0 }
    );
    const We = () => z(this, null, function* () {
      try {
        const { state: c, recordingEnabled: C } = yield Nt.getLiveSessionState(e.licenseId);
        if (c === Ct.COMPLETED) {
          try {
            yield B({
              licenseId: e.licenseId,
              participantToken: oe.value
            });
          } catch (F) {
          }
          U.value = C ? "This session has ended. A recording will be available soon." : "This session has ended.", ae.value = !1, S("stream-ended"), j && (clearInterval(j), j = null);
        } else c === Ct.DISCONNECTED ? (U.value = "The host is reconnecting. Please wait...", ae.value = !0) : c === Ct.LIVE && (U.value = "Waiting for host...", ae.value = !0);
      } catch (c) {
      }
    }), Z = () => z(this, null, function* () {
      j && (clearInterval(j), j = null), yield We(), j = window.setInterval(We, 5e3);
    }), Se = () => {
      j && (clearInterval(j), j = null);
    }, je = () => {
      _(), Ee.value = window.setTimeout(() => {
        I();
      }, 1 * 60 * 1e3);
    }, _ = () => {
      Ee.value && (clearTimeout(Ee.value), Ee.value = null);
    }, I = () => z(this, null, function* () {
      try {
        yield B({
          licenseId: e.licenseId,
          participantToken: oe.value
        }), U.value = "Connection lost. Please refresh to rejoin.", ae.value = !1, S("stream-ended");
      } catch (c) {
      }
    }), w = k(!1), Y = k(!1), Q = k(!1), Ne = () => {
      document.hidden ? Q.value = !0 : Q.value;
    }, Re = (c) => {
      if (!c) return;
      const C = () => {
        const G = J.value || H.value;
        (Q.value || G) && (ve.value || (ve.value = !0), Q.value = !1);
      }, F = () => {
        const G = J.value || H.value;
        (Y.value || G) && ve.value && (ve.value = !1), Y.value = !1;
      };
      return c.addEventListener("play", C), c.addEventListener("pause", F), () => {
        c.removeEventListener("play", C), c.removeEventListener("pause", F);
      };
    }, he = /* @__PURE__ */ new Map();
    $e(
      () => n.value,
      (c, C) => z(this, null, function* () {
        c === pe.Connected && (w.value = !0, U.value = "", ae.value = !1), c === pe.Disconnected && w.value && (yield Z(), w.value = !1), c === pe.Reconnecting || c === pe.SignalReconnecting ? (U.value = "Reconnecting...", ae.value = !0, je()) : (C === pe.Reconnecting || C === pe.SignalReconnecting) && c === pe.Connected && (_(), w.value = !0, U.value = "", ae.value = !1);
      })
    ), rt(() => z(this, null, function* () {
      P.value && !V.value ? yield Z() : P.value && V.value && j && (clearInterval(j), j = null, U.value = "", ae.value = !1);
    }));
    const et = (c, C) => z(this, null, function* () {
      var F;
      C && (oe.value = C);
      try {
        ae.value = !0, U.value = U.value ? U.value : "Connecting to stream...";
        const G = oe.value ? oe.value : (F = yield Nt.generateLiveSessionToken(c, {
          id: e.attendeeId,
          name: e.attendeeName,
          role: Ha.ATTENDEE,
          avatar: e.attendeeAvatar
        })) == null ? void 0 : F.token;
        if (!G) {
          U.value = "Cannot join the stream.", ae.value = !1;
          return;
        }
        oe.value = G;
        const me = yield ee({
          licenseId: e.licenseId,
          participantToken: G,
          skipMediaTransfer: !0
          // Attendees don't need to publish any media
        });
        if (me.startedAt && S("session-started-at", me.startedAt), me.recordingAvailable && S("recording-available", me.recordingAvailable), !me.canJoin) {
          U.value = me.message || "Cannot join the stream.", me.retryInSeconds ? (setTimeout(() => z(this, null, function* () {
            yield et(c, oe.value);
          }), me.retryInSeconds * 1e3), ae.value = !0) : ae.value = !1;
          return;
        }
        U.value = me.message || "Connecting to stream...", yield $(), U.value = "", S("stream-joined");
      } catch (G) {
        U.value = G && typeof G == "object" && "message" in G ? G.message : "Failed to connect", ae.value = !1;
      }
    }), at = () => z(this, null, function* () {
      yield B({
        licenseId: e.licenseId,
        participantToken: oe.value
      }), S("stream-left"), Se();
    });
    return ut(() => {
      e.autoJoin && et(e.licenseId, oe.value), document.addEventListener("visibilitychange", Ne);
    }), _t(() => z(this, null, function* () {
      if (Le && clearTimeout(Le), _(), he.forEach((c, C) => {
        c();
      }), he.clear(), d.value && we(d.value), y.value && we(y.value), x.value && we(x.value), P.value)
        try {
          yield B({
            licenseId: e.licenseId,
            participantToken: oe.value
          });
        } catch (c) {
        }
      j && (clearInterval(j), j = null), document.removeEventListener("visibilitychange", Ne);
    })), h({
      joinStream: et,
      leaveStream: at,
      // Expose video state and controls for external use
      isPlaying: ve,
      isMuted: _e,
      volume: ne,
      togglePlayPause: De,
      toggleMute: Fe,
      setVolume: Ge
    }), (c, C) => {
      var F, G;
      return r(), v("div", {
        ref_key: "playerRef",
        ref: N,
        class: "attendee-player"
      }, [
        o("div", po, [
          o("video", {
            ref_key: "videoElement",
            ref: d,
            playsinline: "",
            autoplay: "",
            class: Ce(["stream-video", { hidden: s(H) }]),
            onClick: De
          }, null, 2),
          ct((r(), v("video", {
            key: ((F = s(ge)) == null ? void 0 : F.trackSid) || "no-screen-share",
            ref_key: "screenShareElement",
            ref: y,
            class: "screen-share-video",
            playsinline: "",
            autoplay: ""
          })), [
            [yt, s(H)]
          ]),
          ct(X(s(Zt), {
            ref_key: "floatingVideoContainer",
            ref: R,
            "initial-x": "16px",
            "initial-y": "16px",
            class: "floating-video-container"
          }, {
            default: Ae(() => [
              o("video", {
                ref_key: "floatingVideoElement",
                ref: x,
                class: "floating-video",
                autoplay: "",
                playsinline: "",
                muted: ""
              }, null, 512)
            ]),
            _: 1
          }, 512), [
            [yt, s(H) && s(J)]
          ]),
          ue.value ? (r(), v("div", fo, [
            ae.value && !c.hideLoadingSpinner ? (r(), v("div", ho)) : E("", !0),
            o("p", yo, de(U.value || "Connecting to stream..."), 1)
          ])) : E("", !0),
          s(P) && s(V) && !s(J) && !s(H) ? (r(), v("div", go, [
            X(Mt, {
              name: s(V).name || "Host",
              image: (G = s(O)) == null ? void 0 : G.avatar,
              size: "medium",
              "is-speaking": s(ye),
              "audio-level": s(re)
            }, null, 8, ["name", "image", "is-speaking", "audio-level"])
          ])) : E("", !0),
          s(P) ? (r(), v("div", So, [
            o("div", bo, [
              X(ta, {
                "dot-size": D.value,
                "text-size": g.value,
                padding: K.value,
                paused: !s(ve)
              }, null, 8, ["dot-size", "text-size", "padding", "paused"]),
              X(ea, { "icon-size": 14 })
            ]),
            s(J) || s(H) ? (r(), v("button", {
              key: 0,
              class: Ce(["play-pause-button", { playing: s(ve) }]),
              onClick: Je(De, ["stop"])
            }, [
              s(ve) ? (r(), be(Jt, {
                key: 1,
                size: b.value,
                color: "white"
              }, null, 8, ["size"])) : (r(), be(Qt, {
                key: 0,
                size: b.value,
                color: "white"
              }, null, 8, ["size"]))
            ], 2)) : E("", !0)
          ])) : E("", !0),
          s(P) ? qe(c.$slots, "controls", { key: 3 }, void 0, !0) : E("", !0),
          qe(c.$slots, "chat", {}, void 0, !0)
        ])
      ], 512);
    };
  }
}), Vo = /* @__PURE__ */ Xe(ko, [["__scopeId", "data-v-0270311a"]]), wo = { class: "controls-container" }, Co = { class: "controls-left" }, xo = ["value"], To = { class: "controls-right" }, _o = /* @__PURE__ */ Ye({
  __name: "StreamAttendeeControlBar",
  props: {
    containerStyle: {},
    barBackgroundColor: { default: "#1e2939" },
    buttonStyle: {},
    buttonHoverStyle: {},
    buttonActiveStyle: {},
    iconStyle: {},
    iconColor: { default: "#ffffff" },
    volumeSliderStyle: {},
    volumeThumbStyle: {},
    volumeTrackStyle: {},
    volumeControlStyle: {},
    padding: {},
    borderRadius: { default: "0" },
    gap: { default: "0px" },
    boxShadow: {},
    backdropFilter: { default: "none" },
    fontFamily: {},
    autoPlay: { type: Boolean, default: !0 },
    autoMute: { type: Boolean, default: !1 }
  },
  setup(W, { expose: h }) {
    gt((re) => ({
      "856235fc": f.barBackgroundColor === "none" ? "linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)" : f.barBackgroundColor,
      a8dd41ca: f.barBackgroundColor === "none" ? "none" : "blur(10px)",
      "30dc32a8": f.gap,
      "45bbe64e": V.value + "px",
      "28fbfe66": f.barBackgroundColor === "none" ? "rgba(0, 0, 0, 0.5)" : f.barBackgroundColor,
      "011747ec": te.value.background || (f.barBackgroundColor === "none" ? "rgba(0, 0, 0, 0.7)" : "rgba(255, 255, 255, 0.2)"),
      "6e512c7d": te.value.transform || "scale(1.05)",
      f48da108: te.value.borderRadius || "4px",
      e5d06a3c: te.value.border || "none",
      bf7583c8: H.value.background || "",
      "15dd69b5": H.value.transform || "scale(0.95)",
      "1611be08": H.value.borderRadius || "4px",
      ff6e2d3c: H.value.border || "none",
      "1cd2c70c": ye.value.height || "4px",
      "1ca8b846": ye.value.background || "rgba(255, 255, 255, 0.3)",
      "32c3ad37": ye.value.borderRadius || "2px",
      "7711a4dd": ge.value.width || "12px",
      "0a4cf084": ge.value.height || "12px",
      "13ee4626": ge.value.background || "white",
      d6215ec8: ge.value.borderRadius || "50%",
      "26fdc13a": ge.value.boxShadow || "0 0 4px rgba(0, 0, 0, 0.3)"
    }));
    const f = W, e = it("streamControls");
    if (!e)
      throw new Error("StreamAttendeeControlBar must be used within StreamProvider");
    const { isConnected: S } = qt(), {
      isPlaying: N,
      isMuted: d,
      volume: y,
      isFullscreen: x,
      togglePlay: R,
      toggleMute: M,
      setVolume: b,
      toggleFullscreen: D
    } = e, g = k(null), K = k(null);
    ut(() => {
      if (f.autoMute && b(0), f.autoPlay && R(), g.value) {
        const re = g.value.parentElement;
        re && (K.value = re);
      }
    });
    const { baseFontSize: ee } = St(K, {
      baseSize: 14,
      // Smaller base size for attendee controls
      referenceWidth: 800,
      minSize: 12,
      maxSize: 18,
      debounceTime: 100
    }), n = a(() => {
      const ze = 16 + 8 * (ee.value - 12) / 6;
      return Math.max(16, Math.min(24, ze));
    }), V = a(() => n.value * 1.8), O = () => {
      R();
    }, P = () => {
      d.value ? b(0.5) : b(0);
    }, $ = (re) => {
      const le = re.target, ze = parseInt(le.value) / 100;
      b(ze);
    }, B = () => z(this, null, function* () {
      yield D();
    }), ke = a(() => t({
      padding: f.padding,
      borderRadius: f.borderRadius,
      boxShadow: f.boxShadow,
      backdropFilter: f.backdropFilter,
      fontFamily: f.fontFamily
    }, f.containerStyle)), J = a(() => t({}, f.buttonStyle)), te = a(() => t({}, f.buttonHoverStyle)), H = a(() => t({}, f.buttonActiveStyle)), q = a(() => t({
      gap: f.gap
    }, f.volumeControlStyle)), xe = a(() => t({}, f.volumeSliderStyle)), ge = a(() => t({}, f.volumeThumbStyle)), ye = a(() => t({}, f.volumeTrackStyle));
    return h({
      // State
      isPlaying: N,
      isMuted: d,
      volume: y,
      isFullscreen: x,
      isConnected: S,
      // Methods
      togglePlay: R,
      toggleMute: M,
      setVolume: b,
      toggleFullscreen: D
    }), (re, le) => (r(), v("div", {
      ref_key: "controlBarRef",
      ref: g,
      class: "attendee-control-bar",
      style: m(ke.value)
    }, [
      o("div", wo, [
        o("div", Co, [
          o("button", {
            class: "control-button",
            style: m(J.value),
            onClick: O
          }, [
            s(N) ? (r(), be(Jt, {
              key: 1,
              size: n.value,
              color: f.iconColor
            }, null, 8, ["size", "color"])) : (r(), be(Qt, {
              key: 0,
              size: n.value,
              color: f.iconColor
            }, null, 8, ["size", "color"]))
          ], 4),
          o("div", {
            class: "volume-control",
            style: m(q.value)
          }, [
            o("button", {
              class: "control-button",
              style: m(J.value),
              onClick: P
            }, [
              !s(d) && s(y) > 0 ? (r(), be(Qa, {
                key: 0,
                size: n.value,
                color: f.iconColor
              }, null, 8, ["size", "color"])) : (r(), be(Ja, {
                key: 1,
                size: n.value,
                color: f.iconColor
              }, null, 8, ["size", "color"]))
            ], 4),
            o("input", {
              type: "range",
              class: "volume-slider",
              style: m(xe.value),
              min: "0",
              max: "100",
              value: s(y) * 100,
              onInput: $
            }, null, 44, xo)
          ], 4)
        ]),
        o("div", To, [
          o("button", {
            class: "control-button",
            style: m(J.value),
            onClick: B
          }, [
            X(qa, {
              variant: s(x) ? "off" : "on",
              size: n.value,
              color: f.iconColor
            }, null, 8, ["variant", "size", "color"])
          ], 4)
        ])
      ])
    ], 4));
  }
}), Oo = /* @__PURE__ */ Xe(_o, [["__scopeId", "data-v-c373cbf1"]]);
export {
  Fo as S,
  Do as a,
  Vo as b,
  jo as c,
  Oo as d,
  No as e
};
